// Global Vars
// Global Domain VAR
var base_DOM;
// Global Array For Support Badge
var supporterlogos = new Array();
currentlogo = 1;
var credits_earned = 0;
// Var for Enlarge Image
var img_cap;
// Slideshow Transcript vars
var max_slide;
var current_slide;
var slide_text;
var slide_img;
// Global Vars for QA Tool
var qids = new Array();
var qgates = new Array();
// Global Var for BI VP Tracking
var prev_hash;
var next_hash;
// set a is iPad var
var isipad = navigator.userAgent.match(/iPad/i) != null;
var startActivitySticky; //will hold a clone of the start activity container


/* START: Prop Conference */



var propConf = {
	config : {
		conferences : [],
		counter : 0,
		runonce : 0
	},
	init : function(){
		propConf.checkForFlag();
	},
	checkForFlag : function(){
		if ($('input#propConf').length > 0) {
			propConf.recursiveCheckForQnaComplete(0);
		}
	},
	updateEarnCredit : function(){
		$('.cme_btn').each(function(){
			var self = this;
			if ($(this).attr('href').indexOf('/qna/processor') > -1) { //if this is an earn credit button and it already has a query string
				var bankedCredits = $('.prop-conf-banked-credits').text();
				var oldHref = $(self).attr('href');
				if ($(self).attr('href').indexOf('?') > -1) {
					$(self).attr('href', oldHref + "&banked=" + bankedCredits);
				}
				else {
					$(self).attr('href', oldHref + "?banked=" + bankedCredits);
				}

			}
		});
	},
	getConferenceData : function(){
		$('.answer-content p').each(function(x){
			var self = this;
			var conference = $(this).text();
			if ($(self).text().indexOf('::') > -1) { //only target the questions with the escape characters, this allows support for other question types on the product
				var splitConf = conference.split('||');

				//defining sections as empty text, structured to easily add default values in this section
				var label = '',
					title = '',
					description = '',
					datetime = '',
					location = '',
					faculty = '',
					credit = '',
					ctype = '';

				for (var i = 0; i < splitConf.length; i++) {
					  
					if (splitConf[i].indexOf('label::') > -1) {
							label = splitConf[i].split('label::');
							label = label[1]
					}
					
					if (splitConf[i].indexOf('title::') > -1) {
							title = splitConf[i].split('title::');
							title = title[1]
					}

					if (splitConf[i].indexOf('description::') > -1) {
							description = splitConf[i].split('description::');
							description = description[1]
					}

					if (splitConf[i].indexOf('datetime::') > -1) {
							datetime = splitConf[i].split('datetime::');
							datetime = datetime[1]
					}

					if (splitConf[i].indexOf('location::') > -1) {
							location = splitConf[i].split('location::');
							location = location[1]
					}

					if (splitConf[i].indexOf('faculty::') > -1) {
							faculty = splitConf[i].split('faculty::');
							faculty = faculty[1]
					}

					if (splitConf[i].indexOf('credit::') > -1) {
							credit = splitConf[i].split('credit::');
							credit = credit[1]
					}

					if (splitConf[i].indexOf('ctype::') > -1) {
							ctype = splitConf[i].split('ctype::');
							ctype = ctype[1]
					}
				}
				
				//conference card template
				var e = '<span class="prop-conf-label">'+ label +'</span>';
				e += '<span class="prop-conf-wrapper">';
				e += '<span class="prop-conf-pillar-one">';
				e += '<span class="prop-conf-title">'+ title +'</span>';
				e += '<span class="prop-conf-description">'+ description +'</span>';
				e += '<span class="prop-conf-datetime">'+ datetime +'</span>';
				e += '<span class="prop-conf-location">'+ location +'</span>';
				e += '<span class="prop-conf-education xs-only">'+ credit +' '+ ctype +'</span>';
				e += '<span class="prop-conf-faculty"><span class="prop-conf-faculty-label">Faculty: </span><span class="prop-conf-faculty-content">'+ faculty +'</span></span>';
				e += '</span>'
				e += '<span class="prop-conf-pillar-two"><span class="prop-conf-pillar-two-col-1 xs-hide">';
				e += '<span class="prop-conf-credit">'+ credit +'</span>';
				e += '<span class="prop-conf-ctype">'+ ctype +'</span>';
				e += '</span>';
				e += '<span class="prop-conf-pillar-two-col-2"></span>';
				e += '</span>';
				e += '</span>';

				if (label == "deselect") {
					$(self).closest('label').hide().find('input').attr('checked','checked');
					//$(self).closest('label').find('input').attr('checked','checked');
				}

				var $parent = $(self).closest('.answer-content');
				$(self).html(e).addClass('prop-conf-card-data');
				$(self).prependTo($parent);
				var $propConfPillarTwo= $parent.find('.prop-conf-pillar-two-col-2');
				$parent.find('ans').appendTo($propConfPillarTwo);
			}
		});
		
		if ($('.cme-question.answered').length > 0) {
			$('.qna-render').hide();
			propConf.answersPageBankUpdates();
		}
		else {
			propConf.answersPageBankUpdates();
			// has expired content?
			if(!propConf.hasExpiredContent()) {
				// runs when there is no expired content
				propConf.bindBankUpdates();
			}
			else {
				// run when content expires
				$('.cme-body.prop-conf').addClass('prop-conf--expired');
				$(".cme-question input[type=checkbox]").each(function () {
					$(this).attr('disabled','disabled');
				});
			}
		}
	},
	creditBankBox : function(){
		if ($('.cme-bodyright .cme-supported').length > 0) {
			$('.cme-bodyright .cme-supported').after("<div class='prop-conf-credit-bank'><span class='prop-conf-credit-time-wrapper'><span class='prop-conf-banked-time'>0</span><span class='prop-conf-banked-time-text'>Minutes Selected</span></span><span class='prop-conf-credit-credits-wrapper'><span class='prop-conf-banked-credits'>0</span><span class='prop-conf-banked-credits-text'>Credits Selected</span></span></div>");
		}
		else {
			$('.cme-bodyright').prepend("<div class='prop-conf-credit-bank'></div>");
		}

		
	},
	bindBankUpdates : function(){
		
		
		$('.prop-conf .answer-content').on('click',function(){
			setTimeout(function(){ //nest in a timeout with zero to push to the end of the que & guarantee the checkbox event completes before updating the value
				var credits = 0;
				$('.cme-question input[type=checkbox]:checked').each(function(){
					var creditAmount = Number($(this).closest('label').find('.prop-conf-credit').text());
					credits = credits + creditAmount;
				});	
				var timeBanked = credits * 60;
				$('.prop-conf-banked-credits').text(credits);
				$('.prop-conf-banked-time').text(timeBanked);
			},0);
			
			
		});
		
		
	},
	answersPageBankUpdates : function(){
		if(propConf.hasExpiredContent()) {
			// when expired content no need to update credits and time right rail info
			return;
		}
		setTimeout(function(){ //nest in a timeout with zero to push to the end of the que & guarantee the checkbox event completes before updating the value
			var credits = 0;
			$('.cme-question input[type=checkbox]:checked').each(function(){
				var creditAmount = Number($(this).closest('label').find('.prop-conf-credit').text());
				credits = credits + creditAmount;
			});	
			var timeBanked = credits * 60;
			$('.prop-conf-banked-credits').text(credits);
			$('.prop-conf-banked-time').text(timeBanked);
			propConf.updateEarnCredit();
		},0);
	},
	recursiveCheckForQnaComplete : function(){		
		if ($('#cme-form-actions').length > 0 || $('.cme-qnaresponse').length > 0) {
			if (propConf.config.runonce < 1) { 
				propConf.config.runonce = 1;
				
				$('.cme-body').addClass('prop-conf'); //.addClass('prop-conf-prep'); //add prop conference identifier to the parent element and a prep tag that will be removed after processing

				//update copy of previous button
				$('#prev_page_nav a').text('Session List');
				
				//question and answer layout update
				propConf.getConferenceData();

				// accordion init
				propConf.initializeAccordion();
				
				// add the credit bank box if content not expired 
				if(!propConf.hasExpiredContent()) {
					propConf.creditBankBox();
				}
				else {
					$('#cme-form-actions > .cme-button').attr('disabled', 'disabled').addClass('disabled').text('activity expired').css('text-transform','capitalize');
					$('#page_nav.show-on-load').addClass('hidden');
				}

			}
		}
		else {
			propConf.config.counter++;
			setTimeout(function(){
				if (propConf.config.counter > 20) {
					console.log("error: timeout waiting for qna response");
				}
				else {
					propConf.recursiveCheckForQnaComplete();
				}
			},500);
		}
	},
	hasExpiredContent: function () {
		// on pagination 2nd page onwords .cme-infolayer-header available to read the expired info from 
		var $cmeHeader = $(".cme-infolayer-header").length ? $(".cme-infolayer-header") : $(".cme-header");
		return !!$cmeHeader.find(".has-expired").length;
	},
	initializeAccordion: function() {
		// prepare accordion structure
		$(".cme-question").each(function(idx, val){
			var $self = $(this);
			$self.find('.question-content').addClass('accordion-title');
			$self.find('> label[for]').wrapAll('<div class="accordion-content"></div>');
		})

		$(".accordion-title").click(function(e){
			e.preventDefault();
			$(this).toggleClass('collapse');
			$(this).closest(".cme-question").find(".accordion-content").slideToggle();
		});
	},
}



$(function(){
		propConf.init();
});

/* END: Prop Conference */








 function nthNumber(number) {
	if (number > 3 && number < 21) return "th";
	switch (number % 10) {
	  case 1:
		return "st";
	  case 2:
		return "nd";
	  case 3:
		return "rd";
	  default:
		return "th";
	}
  };

function formattedTime(timeStr){
	var timesArr  = timeStr.split(":");
	var hourString = timesArr[0];
	var minute = timesArr[1];
	var hour = Number(hourString) % 24;
	return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
}

/* START: Activity Detail */

	var actDetail = {
		config: {
			activityId : '',
			ebacCredits: ''
		},
		setMarkup : function(){
			////////////Identifier////////////
			$('body').addClass('adp-layout');			
			$('.cme-main').addClass('paywall');
			
			////////////Header////////////
			$('.cme-infolayer-container').attr('id','new_pdp_page');
			$('.cme-infolayer-header').eq(0).wrap('<div class="main-header-wrapper no-video">').wrap('<div class="cme-infolayer-header-wrapper">').addClass('pdp-header');
			$('.cme-infolayer-header').eq(0).wrapInner('<div class="headerTitle">')
			
			//Credits Available
			var headerCreditTypes = $('.cme-infolayer-header .headerTitle h4').text();
			$('.cme-infolayer-header .headerTitle').prepend('<div class="credits_sec"><span class="header_credits_amount_sec"></span> '+headerCreditTypes+'</div>');
			
			/* get credits using service */
			var canonArt = $("link[rel='canonical']").attr("href")
			canonArt = canonArt.split('viewarticle/');
			canonArt = canonArt[1].split('?');
            canonArt = canonArt[0].split('#');
			canonArt = canonArt[0].split('_');
			canonArt = canonArt[0];
			var headerCreditAmount = 0;
			
			var  url = "https://www."+getDomain()+"medscape.org/activityservice/getactivitydetails?articleIds=" + canonArt;
				$.ajax({
					async: true,
					timeout: 15000,
					cache: false,
					type: 'GET',
					contentType: 'application/json',
					url: url,
					xhrFields: {
						withCredentials: true
					},
					crossDomain: true,
					success: function(json) {
						actDetail.isShortFormContent = json[0].credits < 0.25
						if (actDetail.isShortFormContent) {
							$('.cme-header .cme-title-block h1').css("margin-top", "0.25em");
							$('.cme-header .cme-credit').hide();
							if($(".cme-credit-info p:first-child").length) {

								$(".cme-credit-info p:first-child").html($(".cme-credit-info p:first-child").html().replace(/;.*/, ''));
							}
							if($('.cme-credit-info p:first-child .cme-label').length) {

								$('.cme-credit-info p:first-child .cme-label').text('Activity Released:');
							}
							if($('.cme-credit-info p:nth-child(2)').length) {

								$('.cme-credit-info p:nth-child(2)').html('<span class="cme-label">Non CME/CE</span>');
							}
							if($('.cme_btn.adp-cta-main-content-btn').length) {

								$('.cme_btn.adp-cta-main-content-btn').text('Activity Info & Disclosures');
							}
							if($('.cme-bodyright .cme_btn').length) {

								$('.cme-bodyright .cme_btn').text('Complete Activity');
							}
							if($('#next_page_nav #cme_btns a').length) {

								$('#next_page_nav #cme_btns a').text('Complete Activity');
							}
							$('.headerTitle .credits_sec').hide();
							$('.headerTitle .subtext.authorDetails').after('<div class="subtext shortFormCreditInfo">Non CME/CE</div>');
							$('.cme-creditsAndBadge-details .credits_section').hide();
							if($(".accreditationWrap").length) {
								$(".accreditationWrap").remove();
							}
						}
						actDetail.config.activityId = json.length ? json[0].activityId : '';
						actDetail.ebacCredits = 60 * json[0].credits + " MIN ";
						if(json[0].priAccreditorId === 1073) {
							$('body').addClass('ebacAccredition')
							
							$('.cme-title-block .cme-credit').css('visibility', 'hidden')
							var releasedLabel = $('.cme-credit-info .cme-label:first').text().replace('CME Released', 'Released')
							$('.cme-credit-info .cme-label:first').text(releasedLabel);

							$('.header_credits_amount_sec').text(actDetail.ebacCredits);
							var headerCreditTypes = $('.cme-infolayer-header .headerTitle .credits_sec').text();
								headerCreditTypes = headerCreditTypes.replace(" CME", "EBAC");
								$('.cme-infolayer-header .headerTitle .credits_sec').text(headerCreditTypes);
								$('.cme-infolayer-header .headerTitle h4').text('');
									var creditsInfo = $('.cme-creditsAndBadge-details .credits_section ul p').html();
									var number = creditsInfo.match(/\d+\.\d+/g); // Find the number in the string
										number = parseFloat(number) * 60;
										creditsInfo = creditsInfo.replaceAll(/\d+\.\d+/g, '');
										creditsInfo = creditsInfo.replaceAll("Maximum of", number + ' minutes of');
										creditsInfo = creditsInfo.replaceAll("Hour(s)", "");
										$(".releaseDates span:contains('CME Released')").replaceWith("<span class='cme-label fntBold'>EBAC Released: </span>");
										$(".releaseDates span:contains('Valid for credit through')").replaceWith("<span class='cme-label fntBold'>Valid through: </span>");

									$('.cme-creditsAndBadge-details .credits_section ul:first p').html(creditsInfo);
						}
						else {
							$('.header_credits_amount_sec').text(json[0].credits);
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						$('.header_credits_amount_sec').text('0');
						console.log("Error connecting to service -- " + errorThrown + ", " + textStatus + ", " + jqXHR);
					}
				});
			
			

			
			//Teaser	
			var teaser = $("meta[name='description']").attr("content");  
			$('.cme-infolayer-header .headerTitle h1').after('<div class="subtext adTeaser">'+teaser+'</div>');
			
			//Authors
			var headerAuthors = '';
			$('.cme-infolayer-header .headerTitle li').each(function(){
				var self = this;
				var liTitle = $(this).find('span').text();
				if (liTitle.indexOf('uthors') > -1) {
					headerAuthors = $(self).html();
					$('.cme-infolayer-header .headerTitle .adTeaser').after('<div class="subtext authorDetails">'+headerAuthors+'</div>');
				}
			});
			
			//Call to Action Button
			$('.headerTitle').append('<div class="btnWrap topSection"></div>');
			
			
			



			////////////Body-Left////////////
			$(".cme-infolayer-content").addClass('cme-infolayer-container').addClass('pdp-body').removeClass('.cme-infolayer-content').wrapInner('<div class="info_cont">');
			$('.info_cont').append('<div class="btnWrap"></div>')

			$('.cme-article-tools').clone().appendTo($('.info_cont'));
			$('.info_cont .cme-article-tools').addClass('sharrow-print');
			$('.cme-infolayer-accredidation').addClass("accreditationWrap").removeClass('cme-infolayer-accredidation');
			$('.cme-infolayer-authoreditors').addClass('panelistsModerators').find('h2').addClass('section_title');
			//$('.cme-infolayer-authorseditors .section_title').wrapInner('<ul class="cme-infolayer-author">');
			

			$('.cme-infolayer-authoreditors .section_title').each(function(i){
				$(this).nextUntil(".section_title, h3").addClass('author-group-'+i);
			});
			
			var authorSectionCount = $('.cme-infolayer-authoreditors .section_title').length
			for (var i = 0; i < authorSectionCount; i++) {
			  var targetClass = ".author-group-"+i;
			  $(targetClass).wrapAll("<div class='pdp-column-layout' />");
			}
			
			$('.pdp-body .cme-infolayer-authordisclosure').each(function(){
				var self = this;
				$(this).find('a').eq(0).remove();
				$(this).find('div').eq(0).addClass('disclosureTextWrap').after("<span class='discloseBtn'>Disclosure <span>+</span></span>");
			});
			
			$('.cme-infolayer-content').on('click', '.discloseBtn', function(){
				var self = this;
				if ($('.modal-popWrap').length < 1){
					var disclaimText = $(self).closest('.cme-infolayer-authordisclosure').find('.disclosureTextWrap').html();
					var section_title_text = $(this).parents('.pdp-column-layout').prev('h2.section_title').text();
					$(this).after('<div class="modal-popWrap"><div class="modal-content"><span class="close-icon"></span><h2>Disclosure</h2>'+disclaimText+'</div></div>');
					$('body').addClass('modalpop-open');
					if(section_title_text.toLowerCase().indexOf("faculty") >= 0){
						wmdPageLink('vwart-discl_fclt');
					}else{
						wmdPageLink('vwart-discl_othr');
					}
					$(this).parent('div').find('.close-icon').on('click',function(){
						$('body').removeClass('modalpop-open');
						$(this).closest('.modal-popWrap').remove();
					});
					$(window).on('click', function(e){
						if ($(e.target).is('.modal-popWrap')) {
							$('body').removeClass('modalpop-open');
							$('.modal-popWrap').remove();
						}
					});
				}
			});

			////////////Right-Rail////////////
			var creditsAvail = 'no credits available';
			if($('.has-expired').length > 0){
				creditsAvail = '';
			}
			
			else if ($('.cme-infolayer-details .cme-infolayer-credits').length > 0){
				creditsAvail = $('.cme-infolayer-details .cme-infolayer-credits').html();
			}
        creditsAvail = creditsAvail.replaceAll(" - ", "");
        creditsAvail = creditsAvail.replaceAll("maximum", "Maximum");

			
			var rightRail = '<div class="cme-creditsAndBadge-details">';
			rightRail += '<ul><li class="supporterWrap">';
			rightRail += '<div class="cme-infolayer-partner">';
            rightRail += $('.cme-bodyright .cme-supported.cme-module').html();
			rightRail += '<li class="credits_section">';
			rightRail += '<h2 class="headingCA">All Credits Available</h2>';
			rightRail += '<ul>';
			rightRail += creditsAvail;
			rightRail += '</ul>';
			

			var creditPostDates = '';
			$('.cme-infolayer-header li span.cme-label').each(function(){
				creditPostDates += '<p>' + $(this).closest('li').html() + '</p>';
			});
			
			rightRail += "<div><ul class='releaseDates'>" + creditPostDates + "</ul></div></li>";
			
			
			if ($('.moc-badge').length > 0) {
				var existingMoc = $('.moc-badge').html();
				rightRail += "<div class='moc-badge'>"+existingMoc+"</div>";
			}

			
			$('.info_cont').after(rightRail);
						
			$('.cme-creditsAndBadge-details .cme-label').addClass('fntBold');
		},
		checkForLockStart: function(){
			var currentDate =  Date.parse(new Date().toLocaleString('en-US', {
				timeZone: 'America/New_York',
			  }));
			  if($('input#lockStart').length > 0){
				if(Date.parse($('input#startDate').val()+' ' +$('input#startTime').val()) > currentDate ){
				  return true;
				}
			  }
			  return false;
		},
		getStartDateTime: function (){
			var dateObj = new Date($('input#startDate').val());
			var day = dateObj.getDate();
			var month = dateObj.toLocaleString("default", { month: "long" });
		  	var year = dateObj.getFullYear();
			return month + ' ' + day+nthNumber(day) +', ' + year +', '+ formattedTime($('input#startTime').val())+ ' EST';
		}
	}


    $(document).ready(function(){
		
		$('.cme_btn').each(function(){
			var theHref = (this).getAttribute("href");
			if (theHref.indexOf('accme_toggle') > 0) {
				$('.cme-bodyleft').prepend(this);
				$(this).addClass('adp-cta-main-content-btn');
				$('.adp-cta-main-content-btn').wrap('<div class="adp-left-content-btn"></div>');
				var cmeBtnText = $('.adp-left-content-btn .cme_btn').text();
				if (cmeBtnText.toLowerCase().indexOf('cpd') > -1) {
					$('.adp-left-content-btn .cme_btn').css('text-transform','initial')
					cmeBtnText = "CPD Info & Disclosures";
				}
				else if (cmeBtnText.toLowerCase().indexOf('cme') > -1 && cmeBtnText.toLowerCase().indexOf('ce') > -1 ) {
					$('.adp-left-content-btn .cme_btn').css('text-transform','initial')
					cmeBtnText = "CME / CE Info & Disclosures";
				}
				else if (cmeBtnText.toLowerCase().indexOf('ce') > -1 ) {
					$('.adp-left-content-btn .cme_btn').css('text-transform','initial')
					cmeBtnText = "CE Info & Disclosures";
				}
				else if (cmeBtnText.toLowerCase().indexOf('cme') > -1) {
					$('.adp-left-content-btn .cme_btn').css('text-transform','initial')
					cmeBtnText = "CME Info & Disclosures";
				}
				
				$('.adp-left-content-btn .cme_btn').text(cmeBtnText);
			}
		});
		
		var authlevel = getAuthLevel();

		// fix for adp alignment isue (PPE-501332)
		$(".cme-infolayer-container p b em").closest('b').css('display', 'inline');

		/*
		if ($('.has-expired').length > 0 && Number(authlevel) < 2) { //if the article is expired and the user is logged out, always display the adp page. 
			// leaving hook for later implementation. We will want to update the expired activity logic to display based on the server side method that determines the displayAccme value.
		} */
		if (Number(authlevel) > 0 && !actDetail.checkForLockStart()) { //if the user is known and activity is ready to start, don't display accme layer
			$('#bodypadding').addClass('actstarted');
		}
		else {
			//leaving hook in case anonymous user logic changes again
		}
		
		if ($('#cme-508-compliance').length > 0) {
			$('#bodypadding').addClass('actstarted');
			$('.cme-header').addClass('compliance508-header');
			if (Number(authlevel) < 1) {
			
				var canonicalUrl = document.querySelector("link[rel='canonical']").getAttribute("href");
				var encryptedUrl = btoa(canonicalUrl);
				
				var adjustedDomain = getDomain();
				adjustedDomain = adjustedDomain.replace('staging.','');
				
				$('#next_page_nav').html('<a class="cme-button cme-action-loginToStart" href="https://login.'+adjustedDomain+'medscape.com/login/sso/getlogin?urlCache='+encryptedUrl+'">Log In to Start</a>');						
				
			}
		}
		else if ($('.cme-infolayer-container').length < 1) {
			$('#bodypadding').addClass('actstarted');
		}
		else {
			actDetail.setMarkup();
		}
		
		/*
		//pre-product script functions
		var isUserLogged = false;
		if (DFPTargetKeys.webSegVars.auth == '1') {
		  isUserLogged = true;
		}
		*/
		
		if(actDetail.checkForLockStart()){
			$('.btnWrap.topSection').append('<div class="start-lock-block"><span class="lock-icon"></span> <p class="start-lock-msg">Check back on ' + actDetail.getStartDateTime() +' to complete this activity</p></div>');
		}else{
			if (authlevel > 0) {
				$('.btnWrap').html('<a class="cme-button cme-action-startActivity">View Activity</a>');
				$('.sharrow-print .share_func .emailIcon').parent().show();
			} else{
				var canonicalUrl = document.querySelector("link[rel='canonical']").getAttribute("href");
				var encryptedUrl = btoa(canonicalUrl);
				
				var adjustedDomain = getDomain();
				adjustedDomain = adjustedDomain.replace('staging.','');
				
				$('.btnWrap').html('<a class="cme-button cme-action-loginToStart" href="https://login.'+adjustedDomain+'medscape.com/login/sso/getlogin?urlCache='+encryptedUrl+'">Log In to Start</a>');
				$('.sharrow-print .share_func .emailIcon').parent().hide();
			}
		}

        $('#bodypadding').on('click','.btnWrap .cme-button', function(){
            var position = $(this).parent('.btnWrap').hasClass('topSection') ? 'top':'bttm';
            if($(this).hasClass('cme-action-loginToStart')){
                wmdPageLink('vwart-login_'+position);
            } else if($(this).hasClass('cme-action-startActivity')){
				$('#bodypadding').addClass('actstarted');
				$('html, body').animate({
					scrollTop: $(".paywall").offset().top
				}, 500);
                wmdPageLink('vwart-view_'+position);
            }
        });

        function setHeroBanner(){
            var pdpHeaderBgImage = '';
            pdpStyles = '';
            if($('.cme-infolayer-header').hasClass('has-bgimage') && $('.cme-infolayer-header').attr('data-pdpBg')){
                pdpHeaderBgImage = $('.cme-infolayer-header').attr('data-pdpBg');
				$('.cme-infolayer-header').attr('data-pdpBg', '');
            }
            if(pdpHeaderBgImage !== ''){
				$('.cme-infolayer-header.has-bgimage.pdp-header').css('background','none');
				$('.cme-infolayer-container .main-header-wrapper').addClass('has-bckimage');
                pdpStyles += '.cme-infolayer-container .main-header-wrapper.no-video.has-bckimage .cme-infolayer-header-wrapper { background-image: url("'+pdpHeaderBgImage+'");}'

            } else{
                var thumbnailPath = $('meta[property="og:image"]').attr('content');
                if(thumbnailPath !== undefined && thumbnailPath !== '' && !thumbnailPath.split("/").pop().startsWith('Social_')){
                    $('.cme-infolayer-container .main-header-wrapper.no-video').addClass('has-article-thumbnail');
                } else{
                    $('.cme-infolayer-container .main-header-wrapper.no-video').addClass('default-banner');
                }
            }
            if($('.has-expired').length>0){
                $('<div class="expiredMsg">THIS ACTIVITY HAS EXPIRED FOR CREDIT</div>').insertAfter( ".btnWrap.topSection" );
            }
            $('<style>').text(pdpStyles).appendTo(".pdp-header");
        }
        setHeroBanner();

    });


/* END: Activity Detail */


















//fire cp event for participation on the first of all article pages
function cmeCpEventArticlePage(article) {
	var cpCmeArticleId = segVarParam("articleId");
	var cpCmeEvent = new Object();
	cpCmeEvent.appname = "cme";
	cpCmeEvent.activityId = article;
	cpCmeEvent.activityName = "participation";
	postCp(cpCmeEvent);
}
function cmeCpParticipate() {
	if (qrllog == 1) { //if the user is logged in
		var articleIdCanon = $("link[rel='canonical']").attr("href");
		articleIdCanonArr = articleIdCanon.split("_");
		if (articleIdCanonArr.length === 1) { //if there is no pagination...
			articleIdCanon = articleIdCanon.split("viewarticle/");
			if (articleIdCanon[1].length < 8) { //failsafe to ignore anything that is greater than 7 characters.  This is in the event that a new or unknown value appended to the canonical url
				cmeCpEventArticlePage(articleIdCanon[1]);
			}
		}
	}
}


$(function(){ 
	$('#cme_btns, #page_nav, .cme-breadcrumb-inner').addClass('show-on-load');
	//hidden by default to reduce flicker effect. There's a failsafe in the css (2 second 'instant' animation to raise opacity) if the page doesn't have edu-article js or if the doc ready function fails
});

//Micro CME//
var microCme = {
	config : {
		canonical : '',
		qnaObj : '',
		qnaObjSorted : [],
		completedTime : 0,
		page : 0,
		qnaId : 0,
		getQnaCounter : 0,
		runOnce : 0,
		chapterReturn : false,
		chapSelectCounter : 0,
		updateButtonCount : 0,
		totalPossibleTime : 0
	},
	init : function(){
		if (microCme.config.runOnce > 0) {
			microCme.definePageAsMicro();
			microCme.pageCheck();
			if (microCme.config.page === 1) {
				microCme.buildChapterList();
			}
			microCme.getQna();
		}
		microCme.config.runOnce++;
	},
	credits : function() {
		var minutes = microCme.config.completedTime;
		var theTime= 0;
		
          if (minutes >= 15 && minutes < 30) {
            theTime = 0.25;
          } else if (minutes >= 30 && minutes < 45) {
            theTime = 0.5;
          } else if (minutes >= 45 && minutes < 60) {
            theTime = 0.75;
          } else if (minutes >= 60) {
			var convertFromTime = microCme.config.completedTime / 60;
			convertFromTime = Math.round(100*convertFromTime)/100;
			convertFromTime = Math.floor(convertFromTime * 4); //multiply by 4 to bring our thresholds of 0.25 up to the nearest whole number and round down
			convertFromTime = convertFromTime / 4; //divide by 4 to return it to 0.25 increments after rounding down.
			theTime = convertFromTime;
          } else {
            theTime = 0.0;
          }
 
		
		
		return theTime;
	},
	definePageAsMicro : function(){
		$('.cme-main').addClass('micro-cme');
	},
	pageCheck : function(){
		var canonical = "";
			var links = document.getElementsByTagName("link");
			for (var i = 0; i < links.length; i ++) {
				if (links[i].getAttribute("rel") === "canonical") {
					canonical = links[i].getAttribute("href")
					microCme.config.canonical = links[i].getAttribute("href")
				}
			}
			
			pageNum = canonical.split('/viewarticle/')[1]
			pageNum = pageNum.split('?')[0];
			pageNum = pageNum.split('_')[1];
			microCme.config.page = pageNum;
			
			
			if (pageNum === undefined || pageNum == "1") {
				$('.cme-main').addClass('page-one');
				microCme.config.page = 1;
			}

			if (pageNum !== undefined && pageNum != "1") { // if not page 1..
				var chapterSelectLink = (microCme.config.canonical);
				chapterSelectLink = chapterSelectLink.split('_');
				chapterSelectLink = chapterSelectLink[0];
				if ($('.cme-breadcrumb').length > 0) { // if a breadcrumb exists.. replace it
					var breadcrumbMarkup = '<div class="cme-breadcrumb-inner show-on-load"><a href="'+chapterSelectLink+'">&lt; RETURN TO CHAPTER SELECT</a></div>'
					$('.cme-breadcrumb').html(breadcrumbMarkup);
				}
				else {
					var breadcrumbMarkup = '<div class="cme-breadcrumb show-on-load"><div class="cme-breadcrumb-inner"><a href="'+chapterSelectLink+'">&lt; RETURN TO CHAPTER SELECT</a></div></div>'
					$('.cme-header-container').prepend(breadcrumbMarkup);
				}
			}

				



	},
	waitForPopulate : function(){
		if ($('.next_page_nav').length < 1 && microCme.config.chapSelectCounter < 15) {
			setTimeout(function(){
				microCme.config.chapSelectCounter++;
				microCme.waitForPopulate();
			},300);
		}
		else {
			var indexPage = microCme.config.canonical;
			indexPage = indexPage.split("_");
			indexPage = indexPage[0];
			$('.next_page_nav').html('<a href="'+indexPage+'">Chapter List </a>');
			microCme.config.chapSelectCounter = 0;
		}
	},
	navLogic : function() {
		endOfChapterArr = [];
		$(microChapters).each(function(i){
			var beforeStart = Number(microChapters[i].startPage) - 1;
			if (beforeStart !== 1) {
				endOfChapterArr.push(beforeStart);
			}
		});
		
		var checkedOnce = false;
		
		$(microChapters).each(function(i){
			var startQA = Number(microChapters[i].startPage);
			var totalPages = $('.qna-render').data('totalpages');

		
			if (microCme.config.page == totalPages && checkedOnce == false) { 
				checkedOnce = true;
				microCme.waitForPopulate();
			}
			
			else if (Number(microCme.config.page) == startQA) {
				$('.prev_page_nav').hide();
			}
			else if (endOfChapterArr.indexOf(Number(microCme.config.page)) > -1 && checkedOnce == false) {
				checkedOnce = true;
				microCme.waitForPopulate();
			}
			
			
		});		
		
	},
	buildChapterList : function(){

		var microChaptersCopy = '<ul class="micro-cme-ul">';
		$(microChapters).each(function(i){
			var e = '<li class="micro-cme-li">';
				e += '<a href="'+microCme.config.canonical+'_'+microChapters[i].startPage+'">';
					e += '<span class="micro-cme-li-type">'+microChapters[i].type+'</span>';
					e += '<span class="micro-cme-li-wrapper-one">';
						e += '<span class="micro-cme-li-title">'+microChapters[i].title+'</span>';	
						e += '<span class="micro-cme-li-wrapper-two">';
							e += '<span class="micro-cme-li-time"><span class="micro-cme-li-time-value">'+microChapters[i].time+'</span><span class="micro-cme-li-time-mins">mins</span></span>';
							e += '<span class="micro-cme-li-button"></span>';
						e += '</span>';
					e += '</span>';
					e += '<span class="micro-cme-li-progress"></span>';
					e += '<span class="micro-cme-li-meta">';
						e+= '<span class="micro-cme-li-startPage">'+microChapters[i].startPage+'</span>';
						e+= '<span class="micro-cme-li-startQA">'+microChapters[i].startQA+'</span>';
						e+= '<span class="micro-cme-li-endQA">'+microChapters[i].endQA+'</span>';		
					e += '</span>';
				e += '</a>';
			e += '</li>';
			microChaptersCopy += e;
		});
		microChaptersCopy += '</ul>';
		
		if ($('.cme-bodyleft p').length > 0) {
			var targetTag = ($('.cme-bodyleft p').length) - 1; //indexed last chapter
			$('.cme-bodyleft p').eq(targetTag).after(microChaptersCopy); //add the chapter list after the last p tag
		}
		else if ($('.cme-bodyleft h3').length > 0) {
			$('.cme-bodyleft h3').eq(0).after(microChaptersCopy);
		}
		else if ($('.cme-bodyleft h2').length > 0) {
			$('.cme-bodyleft h2').eq(0).after(microChaptersCopy);
		}
		else {
			$('.cme-bodyleft').eq(0).after(microChaptersCopy);
		}

		if ($('.has-expired').length > 0 && $('.micro-cme-li').length > 0 && microCme.config.updateButtonCount < 15) {
			$('.micro-cme-li').each(function(i){
				$(this).find('.micro-cme-li-button').html('Start').addClass('start');
			});
		}
		
	},
	getQna : function(){
		if (microCme.config.qnaId == "0") { //only run the getQna if it isn't already defined
			$('#cme_btns .cme_btn').each(function(){
				var self = this;
				var linkString = $(this).attr('href');
				if (linkString.indexOf("qna/processor") > -1) {
					var qnaId = $(this).attr('href');
					qnaId = qnaId.split('processor/');
					qnaId = qnaId[1];
					qnaId = qnaId.split('?');
					qnaId = qnaId[0];
					microCme.config.qnaId = qnaId;
				}
			});
			if (microCme.config.qnaId == "0" && microCme.config.getQnaCounter < 10) {
				microCme.config.getQnaCounter++;
				setTimeout(function(){
						microCme.getQna();
				},800);
			}
			else {
				var  url = "https://api."+getDomain()+"medscape.org/servicegateway/v2/auth/qnaservice/questionnaire/"+microCme.config.qnaId+"/";
				$.ajax({
					async: true,
					timeout: 15000,
					cache: false,
					type: 'GET',
					contentType: 'application/json',
					url: url,
					xhrFields: {
						withCredentials: true
					},
					crossDomain: true,
					success: function(json) {
						microCme.config.qnaObj = json;
						microCme.processQna();
					},
					error: function(jqXHR, textStatus, errorThrown) {
						console.log("Error connecting to service -- " + errorThrown + ", " + textStatus + ", " + jqXHR);
					}
				});
			}
		}
	},
	processQna : function(){
		//sort qna into array matching form ids
		$(microCme.config.qnaObj.questionForms).each(function(){
			var arrayIndex = $(this)[0].formId;
			microCme.config.qnaObjSorted[arrayIndex] = this;
		});
		
		microCme.navLogic();
		
		//if landing page:
		if (microCme.config.page == "1") {
			microCme.updateButtons();
		}
		else {
			microCme.buildTotals(); //may be worth adding getTotals on page 1 as well and removing the redundant logic from updateButtons
		}
		
		//if any page:
		microCme.updateCredits();
		
	},
	buildTotals : function(){
		microCme.config.totalPossibleTime = 0
		$(microChapters).each(function(i){
			var startQA = microChapters[i].startQA;
			var endQA = microChapters[i].endQA;
			var startedForm = microCme.config.qnaObjSorted[startQA];
			var endedForm = microCme.config.qnaObjSorted[endQA];
			
			microCme.config.totalPossibleTime = Number(microCme.config.totalPossibleTime) + Number(microChapters[i].time);
			
			var sectionComplete = false;
			$(endedForm.questions).each(function(i){
				if (endedForm.questions[i].answered == true && startedForm.questions[i].answered == true) {
					sectionComplete = true;
				}
			});
			if (sectionComplete === true) {
				$(this).find('.micro-cme-li-button').html('Review').addClass('review');
				$(this).find('.micro-cme-li-progress').html('<span style="color: #53dbc3;font-family: proxima_nova_ltlight;font-size: 14px;font-weight: 400;font-weight: 600;font-style: italic;font-stretch: normal;line-height: normal;letter-spacing: normal;">Completed</span>');
				var timeCompleted = microChapters[i].time;
				microCme.config.completedTime = microCme.config.completedTime + Number(timeCompleted);
			}
		});
	},
	updateButtons : function(){
		microCme.config.totalPossibleTime = 0
		if ($('.micro-cme-li').length > 0 && microCme.config.updateButtonCount < 15) {
			$('.micro-cme-li').each(function(i){
				var startQA = microChapters[i].startQA;
				var endQA = microChapters[i].endQA;
				var startedForm = microCme.config.qnaObjSorted[startQA];
				var endedForm = microCme.config.qnaObjSorted[endQA];
				
				microCme.config.totalPossibleTime = Number(microCme.config.totalPossibleTime) + Number(microChapters[i].time);
				
				var sectionComplete = false;
				$(endedForm.questions).each(function(i){
					if (endedForm.questions[i].answered == true && startedForm.questions[i].answered == true) {
						sectionComplete = true;
					}
				});
				if (sectionComplete === true) {
					$(this).find('.micro-cme-li-button').html('Review').addClass('review');
					$(this).find('.micro-cme-li-progress').html('<span style="color: #53dbc3;font-family: proxima_nova_ltlight;font-size: 14px;font-weight: 400;font-weight: 600;font-style: italic;font-stretch: normal;line-height: normal;letter-spacing: normal;">Completed</span>');
					var timeCompleted = $(this).find('.micro-cme-li-time-value').html();
					microCme.config.completedTime = microCme.config.completedTime + Number(timeCompleted);
				}
				else {
					var sectionStarted = false;
					$(startedForm.questions).each(function(i){
						if (startedForm.questions[i].answered === true || endedForm.questions[i].answered === true) {
							sectionStarted = true;
						}
					});
					if (sectionStarted === true) {
						$(this).find('.micro-cme-li-button').html('Resume').addClass('resume');
						$(this).find('.micro-cme-li-progress').html('<span style="color: #f69b6f;font-family: proxima_nova_ltlight;font-size: 14px;font-weight: 400;font-weight: 600;font-style: italic;font-stretch: normal;line-height: normal;letter-spacing: normal;">In-Progress</span>');
					}
					else {
						$(this).find('.micro-cme-li-button').html('Start').addClass('start');
					}
				}	
			});
			microCme.config.updateButtonCount = 0;
		}
		else {
			setTimeout(function(){
				microCme.config.updateButtonCount++;
				microCme.updateButtons();
			},300);
		}
	},
	updateCredits : function() {
	
		var counter = 0;
		if ($('#cme-content_btn_row').length < 1 && $('.micro-cme-credits-completed-box').length < 1 && counter < 15) {
			setTimeout(function(){
				counter++
				microCme.updateCredits();
			},500);
		}
		else {
			

		var totalCredits = microCme.credits();
		
		
		
		//require all articles if no value is set in requiredMicroCredit
		if (typeof(microRequiredCredit) == "undefined") {
			if (microCme.config.completedTime < microCme.config.totalPossibleTime) {
				$('#cme_btns .cme_btn').each(function(){
					var self = this;
					if ($(this).text().indexOf('Earn') > -1) {
						var href = $(self).attr('href');
						$(self).attr('href','javascript:void(0)');
						$(self).attr('data-src',href);
						$(self).off('click');
						$(self).css('background-color','gray');
						$(self).css('cursor','default');
						$(self).css('text-decoration','none');
						$(self).css('margin','auto');
						$(self).css('margin-top','10px');
						$(self).css('margin-bottom','20px');
						$(self).addClass('microEarnCreditBtn');
					}
				});
			}
		}

		//require all articles if requiredMicroCredit is set to "all" or "max"
		if (typeof(microRequiredCredit) != "undefined") {
			if (microRequiredCredit == "all" || microRequiredCredit == "max") {
				if (microCme.config.completedTime < microCme.config.totalPossibleTime) {
					$('#cme_btns .cme_btn').each(function(){
						var self = this;
						if ($(this).text().indexOf('Earn') > -1) {
							var href = $(self).attr('href');
							$(self).attr('href','javascript:void(0)');
							$(self).attr('data-src',href);
							$(self).off('click');
							$(self).css('background-color','gray');
							$(self).css('cursor','default');
							$(self).css('text-decoration','none');
							$(self).css('margin','auto');
							$(self).css('margin-top','10px');
							$(self).css('margin-bottom','20px');
							$(self).addClass('microEarnCreditBtn');
						}
					});
				}
			}
		}

		//require all credits for Nurse or Pharma
		if (typeof(s_user_group != "undefined")) {
			var userProfession = s_user_group.toLowerCase()
			if (userProfession.indexOf('nurse') > -1|| userProfession.indexOf('pharma') > -1){
				if (microCme.config.completedTime < microCme.config.totalPossibleTime) {
					$('#cme_btns .cme_btn').each(function(){
						var self = this;
						if ($(this).text().indexOf('Earn') > -1) {
							var href = $(self).attr('href');
							$(self).attr('href','javascript:void(0)');
							$(self).attr('data-src',href);
							$(self).off('click');
							$(self).css('background-color','gray');
							$(self).css('cursor','default');
							$(self).css('text-decoration','none');
							$(self).css('margin','auto');
							$(self).css('margin-top','10px');
							$(self).css('margin-bottom','20px');
							$(self).addClass('microEarnCreditBtn');
						}
					});
				}
			}
		}
			

		if (typeof(microRequiredCredit) != "undefined" && totalCredits < Number(microRequiredCredit)) {
			//$('#cme_btns .cme_btn').remove();
			$('#cme_btns .cme_btn').each(function(){
				var self = this;
				if ($(this).text().indexOf('Earn') > -1) {
						var href = $(self).attr('href');
						var data_src = href+'&banked='+totalCredits;
						$(self).attr('href','javascript:void(0)');
						$(self).attr('data-src',data_src);
						$(self).off('click');
						$(self).css('background-color','gray');
						$(self).css('cursor','default');
						$(self).css('text-decoration','none');
						$(self).css('margin','auto');
						$(self).css('margin-top','10px');
						$(self).css('margin-bottom','20px');
						$(self).addClass('microEarnCreditBtn');
				}
			});
		}
		}
	
		
		var e = '<span class="micro-cme-credits-completed-box"><span class="credits-box-credits-wrap"><span class="credits-box-completed"><span class="minutes-box-completed-amount">'+microCme.config.completedTime+'</span><span class="minutes-box-completed-amount-text">mins completed</span></span><span class="credits-box-suggested"><span class="credits-box-completed-amount">'+totalCredits+'</span><span class="credits-box-completed-amount-text">suggested credits earned</span></span></span></span>';
		if ($('.micro-cme-credits-completed-box').length < 1) {
			$('#cme-content_btn_row').prepend(e);
		}

	},
	updateCreditsValues : function() {
		
	}
}        






// Realize IT get link and replace href
var realizeItSetup = {
	init : function(provider, article, activity, target){
		var  url = "https://www."+getDomain()+"medscape.org/activityservice/getLTIConfig/" + provider + "/" + article + "/" + activity;
		$.ajax({
			async: false,
			cache: false,
			type: 'GET',
			contentType: 'application/json',
			url: url,
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(json) {
				realizeItSetup.buildForm(json, target);
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log("Error connecting to service - " + errorThrown + ", " + textStatus + ", " + jqXHR);
			}
		});
	},
	buildForm : function(json, target){
		//originally set up as ajax, but requested to convert to hidden form.
		var e = "<form id='ltiForm' action='"+json.launchUrl+"' method='POST'>";
		for(var theKey in json.ltiParam){
			e+= '<input name="'+theKey+'" type="hidden" value="'+json.ltiParam[theKey]+'">';
		}
		e += "</form>";
		$('body').prepend(e);
		realizeItSetup.replace(json, target);
	},
	replace : function(json, target){
		$(target).on('click',function(){
			if (qrllog != 0) { //single equal to account for strings
				wmdPageLink('lti-click');
				$("#ltiForm").submit();
			}
			else {
				$('.errorMsg').remove();
				$(target).append('<div class="errorMsg"><br />Please log in to proceed.</div>');
			}
		});	
	}
}


//Ready Function for .ORG Article
$(document).ready(function() {
	lazyLoadImages();
	
	
	cmeCpParticipate();

	if($('.podcast-apple')){
		if(!$('.podcast-apple img').attr('alt')){
			$('.podcast-apple img').attr('alt', 'Apple Podcast');
		}
	}
	if($('.podcast-google')){
		$('.podcast-google').closest('.confsection').hide();
		// if(!$('.podcast-google img').attr('alt')){
		// 	$('.podcast-google img').attr('alt', 'Google Podcast');
		// }
	}

	$(".sidebar_links a[class^='podcast-']").on('click',function(){
		var podClass = $(this).attr('class');
		podClass = podClass.split(" "); //in the case of multiple classes...
		$(podClass).each(function(){
			if (this.indexOf("podcast-") > -1) {
				var company = this.replace('podcast-','');
				wmdPageLink('rrpod_'+company)
			}
		});
	});

	$('.cme-infolayer-container .cme-infolayer-xclose').attr('onclick',"wmdPageLink('vwart-cls')");
	var istablepagination = $("[name=\"tabletpagination\"]").attr("content");
	var isapp = $.cookie('src');
	if(istablepagination && isapp === 'medscapeapp-ipad') {
		$("body").addClass("is-medscape-app");
	}
	// check if the page is expert commentary if so don't show the translations nav
	var $expertcommentary = $(".cme-module h3:contains('Expert Commentary')");
	var bshowTranslationNav = true;
	if($expertcommentary.length != 0) {
		var $section = $expertcommentary.parent();
		var pageurl = location.href;
		$section.find("li a").each(function() {
			var $link = $(this);
			if(pageurl.indexOf($link.attr("href")) > -1) {
				bshowTranslationNav = false;
			} // end if
		}); // end each()
	} // end if
	if(bshowTranslationNav)
		$(".cme-translations").css("display", "inline-block");

	// Add the Page Blocking Layer into the DOM for all layers
	//$('body').prepend('<div id="page_cover">&nbsp;</div>');
	//$('#page_cover').hide();

	// add moc badge
	if (typeof userValues.isMocEligible !== 'undefined') {
		if (userValues.isMocEligible === true) {
			$('body').addClass('moc-eligible');
		}
	}

	// Replace "AACME check" with "true" when the article is expired.
	/*
	if ($('#cme_expired').length > 0) {
		accme_toggle();
		setTimeout(function () {
			$('#page_cover').css('display', 'block')
		}, 0);
	}
	*/
	//sh*tty dbl arrow removal
	var buttonCheck = jQuery("div.btn a").text();
	if(buttonCheck.indexOf("»") > 0){
		jQuery("div.btn a").text("Continue");
	}

	//add class to the subtitle; backend could not achieve this
	var url = window.location.href;
	var currentSubtitlePage = url.split("/");
	var translationsPage = currentSubtitlePage[currentSubtitlePage.length-1];
		jQuery(".cme-translations ul li a").removeClass("selected");
		
	jQuery(".cme-translations ul li a").each(function(a,b){
		if(jQuery(b).attr("href") == translationsPage){
			jQuery(b).addClass("selected");
		}
	});

	//make #page_nav_top like the bottom nav
	jQuery(".cme-bodyleft #page_nav > *").each(function(a,b){
     	jQuery(b).addClass(jQuery(b).attr("id"));
     	jQuery(".cme-bodyleft #page_nav_top").html(jQuery("#page_nav").html()).css({"margin":"2em auto","opacity":"1"});
	});

	// add omniture tracking for the top nav
	var $prevnav = jQuery(".cme-bodyleft #page_nav_top .prev_page_nav a");
	if($prevnav.length > 0)
		$prevnav.attr('onclick','wmdTrack(\"vwart-prev_top\")');
	var $nextnav = jQuery(".cme-bodyleft #page_nav_top .next_page_nav a");
	if($nextnav.length > 0)
		$nextnav.attr('onclick','wmdTrack(\"vwart-next_top\")');
/*
	// check for pdf support
	var mimes = navigator.mimeTypes;
	var PDFsupport = false;
	for (var i = 0, i_len = mimes.length; i < i_len; i++) {
		if (mimes[i].type === 'application/pdf') {
			PDFsupport = true;
			break;
		}
	}

	// show iframe pdf for chrome desktop only
	if (typeof window.chrome === "undefined") {
		if (navigator.userAgent.indexOf('MSIE') != -1 && Number(navigator.userAgent.match(/MSIE \d+/)[0].split(' ')[1]) == 8) {
			jQuery("#inlinePdfChrome").show();
			jQuery("#inlinePdfNonChrome").hide().remove();

		} else {
			jQuery("#inlinePdfChrome").remove();
			jQuery("#inlinePdfNonChrome").show();
		}
	} else {
		//chrome only pdf support check.
		if (PDFsupport === true) {
			jQuery("#inlinePdfNonChrome").remove();
			jQuery("#inlinePdfChrome").show();
		} else {
			jQuery("#inlinePdfChrome").remove();
			jQuery("#inlinePdfNonChrome").show();
		}
	}

	// Provide a clickable layer on embedded pdfs for iPhone 8.3+
	if ($('#inlinePdfNonChrome').length > 0) { //This div id should only appear on sidebar pages that contain pdfs
		var iosVerCheck = function () { //version checking.  This function currently returns "less than 8, 8.0-8.299 or 8.3+"
			var deviceAgent = navigator.userAgent.toLowerCase();
			if (/(iphone|ipod|ipad).* os 8_/.test(deviceAgent)) {
				if (/(iphone|ipod|ipad).* os 8_0/.test(deviceAgent) || /(iphone|ipod|ipad).* os 8_1/.test(deviceAgent) || /(iphone|ipod|ipad).* os 8_2/.test(deviceAgent)) {
					return "8083" //iOS version 8.0 through version 8.2999
				}
				else {
					return "83plus" //iOS version 8.3 and greater
				}
			}
			else if (/(iphone|ipod|ipad).* os 7_/.test(deviceAgent) || /(iphone|ipod|ipad).* os 6_/.test(deviceAgent)) {
				return "lessthan8" //iOS 6 or 7
			}
		}
		if (iosVerCheck() == "83plus") {
			coverWidth = $('#inlinePdfNonChrome object').css('width');
			coverHeight = $('#inlinePdfNonChrome object').css('height');
			coverSrc = $('#inlinePdfNonChrome object').attr('data');
			$('#inlinePdfNonChrome').prepend('<div id="inlinePdfChromeCover" style="position:absolute;height:' + coverHeight + ';width:' + coverWidth + ';">&nbsp;</div>')
			$('#inlinePdfChromeCover').on('click', function () {
				window.location = coverSrc;
			});
		}
	}
*/
	// Moving "Global Perspectives" box below video
	if (document.getElementById('videoExpert')) {
		$('#videoExpert').insertAfter('.flashvid');
	}

	// Grab The Domain from the Canonical URL
	if ($('link[rel=canonical]').attr("href")) {
		var con_part = window.location.href.split('/');
		base_DOM = "//" + con_part[2];
	}

	// If a corect answer cell exists replace the full text character check
	$.each($('.correctanswer'), function () {
		$(this).html("&nbsp;<b style=\"font-size: 1.50em;\">&radic;</b>&nbsp;");
	});

	// sticky setting for iphone6 or mobile devices
	if ((navigator.userAgent.match(/iPhone/i) && navigator.userAgent.match(/6.0/i)) || (navigator.userAgent.match(/iPod/i) && navigator.userAgent.match(/6.0/i))) {
		iphone6 = true;
		$('#slide_nav_bar').css('position', 'fixed');
		$('#slide_nav_bar').css('bottom', '0');
		$('#slide_nav_bar').css('display', 'block');

		$('#btn_cme_activity').css('position', 'fixed');
		$('#btn_cme_activity').css('bottom', '0');
		$('#btn_cme_activity').css('display', 'block');
	}
	else {
		// Touch Events for the Scrolling elements
		document.addEventListener('touchstart', function (event) {
			$('#slide_nav_bar').hide();
			if ($(event.target).closest('div').attr('id') != 'btn_cme_activity')
				$('#btn_cme_activity').hide();
		}, false);

		document.addEventListener('touchend', function (event) {
			if (document.getElementById("slide_nav_bar")) {
				$('#slide_nav_bar').fadeIn();
				document.getElementById('slide_nav_bar').style.top = (window.pageYOffset + window.innerHeight - 42) + 'px';
			}

			if (document.getElementById("btn_cme_activity")) {
				$('#btn_cme_activity').fadeIn();
				document.getElementById('btn_cme_activity').style.top = (window.pageYOffset) + 'px';
			}
		}, false);
/*
		//Move slide nav bar and CME continue button on scroll
		window.onscroll = function () {
			if (document.getElementById("slide_nav_bar")) {
				document.getElementById('slide_nav_bar').style.top = (window.pageYOffset + window.innerHeight - 42) + 'px';
			}
			document.getElementById('btn_cme_activity').style.top = (window.pageYOffset) + 'px';
		};
*/
	}

	// Hide the entire page when the ACCME layer is displayed
	// ACCME Layer Check - on page load show if ture or keep hidden if false	
	
	
	if ($('input[name="displayAccme"]').val() == "true" && $("#accme_layer").length != 0) {
		if ($('.disableAccmeOverlay').length === 0) {
			//$('#page_cover').show();
			$('#accme_layer').show();
		}
		// Hack for replacing instances of 70% passing score in the AACME layer with 75%
		var str = document.getElementById("accme_layer").innerHTML;
		var n = str.replace("you must receive a minimum score of 70% on the post-test.<br>", "you must receive a minimum score of 75% on the post-test.<br>");
		document.getElementById("accme_layer").innerHTML = n;
	}

	// Show and Hide Theme Nav
	$('#theme_nav_link, #theme_nav_bucket').bind('mouseover', function () {
		$('#theme_nav_bucket').show();
		//Removed for lack of proper function in IE 7 & 8
		//$('#theme_nav_bucket').animate({
		//opacity: 'show',
		//height: 'show'
		//}, 500, function() {
		// Animation complete.
		//});
	});
	$('#theme_nav_link, #theme_nav_bucket').bind('mouseout', function () {
		$('#theme_nav_bucket').hide();
	});
	$("body").click(function () {
		$('#theme_nav_bucket').hide();
	});

	// Quick Hack For A Lack of CSS first and Last child support in IE
	$("#edu_left_col .supporting_links li:first-child a").css("padding-left", "0");
	$("#edu_left_col .supporting_links li:last-child a").css("border-right", "none");
	$("div.qacontainer :button").css({
		"margin-top": "12px",
		"font-size": "1.10em",
		"width": "auto",
		"cursor": "pointer"
	});
	$("div.qacontainer :button").removeAttr("class");
	$("div#edu_left_col div.qacontainer:first").css({
		"width": "722px"
	});

	// Supporter Badge Set-up
	$('#supporter_logo').attr("src", supporterlogos[0]);
	$('#supporter_logo_accme').attr("src", supporterlogos[0]);
	if (supporterlogos.length > 1) {
		setInterval("nextsupporterlogo()", 3000);
	}


	// Slideshow Transcript Set-up
	max_slide = $('#slide_list .slide_sec').length;
	$('#max_slide').html(max_slide);

	// Add "Part X" to View Program TOC
	var pro_num = 1;
	$.each($('ol#program_toc_list li a.title'), function () {
		$(this).prepend("Part&nbsp;" + pro_num + ".&nbsp;");
		pro_num++;
	});

	// Question Tool
	if (document.getElementById("slide_list")) {
		//alert("set up question tool")
		startQAPlugin();
		var qlen = qids.length - 1;
		for (i = 0; i <= qlen; i++) {
			qgates[i] = "false"
		}
	}

	//BI tracking clicks for Next & Previous buttons
	$(document).on('click', 'a#prev_btn', function () {
		//alert("bi track");
		BItrack(prev_hash);
	});
	$(document).on('click', 'a#next_btn', function () {
		//alert("bi track");

		BItrack(next_hash);
	});

	// Show and Hide Theme Nav
	$("#theme_nav_link").click(function () {
		$('#theme_nav_bucket').animate({
			opacity: 'show',
			height: 'show'
		}, 500, function () {
			// Animation complete.
		});
	});
	$("body").click(function () {
		$('#theme_nav_bucket').hide();
	});

	// code for populating any json content buckets on article page
	jQuery.each($(".josn_pop"), function () {
		var testRel = $(this).attr('rel');
		var testEl = $(this);
		$.getJSON(base_DOM + "/noscan/public/json/cvn/themes/" + $(this).attr('rel') + ".json?timestamp=" + new Date().getTime().toString(), function (data_jsonpop) {
			for (y = 0; y < data_jsonpop.json_bucket.length; y++) {
				var bg_resultline = document.createElement("div");
				bg_resultline.className = "theme_item";
				bg_resultline.innerHTML = '<a href="' + data_jsonpop.json_bucket[y].uri + '">' + data_jsonpop.json_bucket[y].ti + '</a>';
				if (testEl.attr('rel') == testRel) {
					testEl.append(bg_resultline);
				}
			}
		});
	});

	/*
	 // Hide & Remove the Documentum produced discussion button
	 var distxt=/Discussion/gi;
	 $.each($('#content_btn_row span a.content_type'), function() {
	 if ($(this).html().match(distxt)) {
	 $(this).css("display","none");
	 $(this).remove();
	 }
	 });
	 */

	/*
	// Hack to Copy 'Earn CME Credit' Button to Bottom of Single-page Transcripts
	if (document.getElementById('cme_btns') !== null || undefined) {
		var buttonCopy = "";
		var i;
		var x = document.getElementById('cme_btns').getElementsByTagName('a');
		for (i = 0; i < x.length; i++) {
			if (x[i].innerHTML.indexOf('Earn') !== -1) {
				buttonCopy = "<a class=\"cme_btn\" href=\"" + x[i].href + "\">" + x[i].innerHTML + "</a>";
			}
		}

		if ((window.location.href.indexOf("_transcript") !== -1) && (document.getElementById("page_nav") == null || undefined) && (buttonCopy !== "")) {
			var divTemp = document.createElement("div");
			divTemp.setAttribute("id", "page_nav");
			divTemp.innerHTML = "<div class=\"spacer\">&nbsp;</div><div id=\"next_page_nav\"><span id=\"cme_btns\">" + buttonCopy + "</span></div><div class=\"spacer\">&nbsp;</div>";
			document.getElementById('text_article').appendChild(divTemp);
		}
	}
	*/

	/*
	// Hack to prevent H2 border running into TOC on multipage articles
	if ($('#cme_toc_top').length > 0) {
		$('#text_article h2:eq(0)').css('margin-right', '320px');
	}
	*/

	/*
	// Attach CP to Print Function
	$('.print_func').click(function () {
		socialCp('print');
	});

	// CP Article/Collection View
	if (window.location.href.match(/viewcollection\/\d+/)) {
		cpArticleLoad('collection');
	}
	else {
		cpArticleLoad('viewarticle');
	}
	*/

	// Hack to Copy 'Earn CME Credit' Button to Bottom of Single-page Transcripts
	if ((window.location.href.indexOf("_transcript") !== -1) && (document.getElementById("page_nav") == null || undefined)) {
		var $cme_btns = $('.cme_btn');
		var $cme_btn_copy = null;

		// get the earn cme credit button
		if ($cme_btns && $cme_btns.length > 0) {
			var $cme_btn_copy = null;
			$cme_btns.each(function () {
				var $cme_btn = $(this);
				if ($cme_btn.html().indexOf("Earn") > -1) {
					$cme_btn_copy = $cme_btn.clone();
					return false;
				} // end if
			}); // end each
		} // end if
		var $cme_bodyleft = $(".cme-bodyleft");
		if($cme_btn_copy && $cme_bodyleft && $cme_bodyleft.length > 0) {
			$cme_btn_copy.attr("onclick","wmdTrack('vwart-erncr_bttm');"); // add bottom tracking
			$cme_btn_copy.addClass("cme_erncr-bttm_btn");
			$cme_bodyleft.append("<div id=\"page_nav\"></div>");
			$("#page_nav").append($cme_btn_copy);
		} // end if
	} // end if

	/////////////////////////////////
	// new cme

	// Add class to the first cme-body if using the newer player
	if ($('.cme-body').length > 0) {
		$('#edu_article:eq(0)').addClass('mediaPlayer2');
	}
	
	// initialize the modal layer
	modallayer.init();

	// init compliance logic before anything else
	govern_compliance_508.init();

	// initialize the info layer
	infolayer.init();

	// support badge initialization
	supportedbadges.init(".supporter_badge_accme");
	//supportedbadges.init(".cme-infolayer-supportedby");

	//slideshow.init();
	slideshow2.init();

	// initialize the legacy flash/mp4 video
	flashvid.init();

	// initialize the qna logic
	qna.init();

	// initialize legacy cmetv player
	cmetv.init();

	// initialize practice challenge
	practicechallenge.init();

	// initialize inline pdf content
	inlinepdf.init();

	// emailthis popup
	emailthispopup.init();

	// move the collection info link to the breadcrumb link
	var $cilink = $("#collectioninfo a");
	var $bclink = $(".cme-breadcrumb-inner a")
	if($cilink.length !== 0 && $bclink.length !== 0)
		$bclink.attr("href", $cilink.attr("href"));

	// add link to go back to main article page for Download slides and append legal text
	var $dlslide = $("#dlSlides");
	var $bodyleft = $(".cme-bodyleft");
	var $h1title = $("#title_block .cme-title-block h1");
	var pageurl = window.location.href;
	var articleid = DFPTargetKeys.pageSegVars.art;
	if($dlslide && $dlslide.length > 0 && $bodyleft && $bodyleft.length > 0 &&
			$h1title && $h1title.length > 0 && pageurl.indexOf("_slide") > -1) {
		var articleurl = articleid;

		// check if the legal text
		if($(".legaltext").length == 0) {
			$dlslide.append("<p class=\"legaltext\">Medscape Education makes these downloadable slides available solely for non-commercial use by you as a reference tool. You may not use these slides for any commercial purpose or provide these slides to any third party for such party’s use for any commercial purpose. Please refer to the Medscape <a href=\"//www.medscape.com/public/termsofuse\" target=\"_blank\">Terms of Use</a> for additional details.</p>");
		} // end if

		$bodyleft.append("<p><a href='"+articleurl+"'>« Return to: "+$h1title.html()+"</a></p>");
	} // end if

	// replace links with [href=javascript:history.back()] to go to main page
	$("a[href$=\"javascript:history.back()\"]").attr("href",articleid);

	if(pageurl.indexOf("_slide") > -1){
		$('#cme_btns a.cme_btn').css('display', 'none');
	}

	/* show more/less toggle
	$(".cme-show-more").click(function (e) {
		$(this).next().slideToggle("slow")
		$(this).toggleClass("authorDisclosureToggleOpen");
		e.preventDefault();
	});
	*/

	if($(".has-expired").length > 0) {
		$("body").addClass("is-expired");
	}

	//show/hide top activity container
	jQuery(".cme-infolayer-container").on("scroll", function(){
			maintainActvityBarWidth();
			if(jQuery(this).scrollTop() < 300 && jQuery(".startActivitySticky").length <= 0){
				//if(jQuery(window).width() <= 768){  //restricts to mobile if needed
					createStartActivitySticky();
				//}
			}
		if(jQuery(this).scrollTop() >= 300){
			if(jQuery(".startActivitySticky").length > 0){
				//if(jQuery(window).width() <= 768){  //restricts to mobile if needed
				     jQuery(startActivitySticky).addClass("showStartActivitySticky");
				//}
			}else{
				//createStartActivitySticky();
			}
		}
		if(jQuery(this).scrollTop() < 300){
				jQuery(startActivitySticky).removeClass("showStartActivitySticky");
		}
	}); //show/hide startActivitySticky

	maintainActvityBarWidth();
	setHeaderBackgroundImage();
	cmeVideoCheck();
	jQuery("table.inline_data_table").wrap("<div class='content-tablewrap'></div>");

	// disable link clicking if selected
	$(".cme-translations .selected").each(function(){
		$(this).attr("href","javascript: void(0)");
	});

	if($(".article-video").length != 0)
		$("body").addClass("has-video");

	// check if the page is a journal article by checking the meta tag
	if($("[content=\"journal article\"]").length != 0) {
		// add the expand icon image element after the thumbnail
		$(".fig_table .thumb_img").after("<div class=\"expand-icon\"></div>");
		$(".fig_table").addClass("fig_table_journal");
		$(".fig_table").after("<div class=\"clear\"></div>")

		// set the class of the active item in the TOC of a journal article
		var $li = $("#cme_toc_top .article_nav_list li b").parent();
		if($li.length != 0) {
			$li.addClass("is-active");
		} // end if
	} // end if

		if(jQuery(".pdfDownloadsContainer ul li").length == 0){
			jQuery(".pdfDownloadsContainer").hide();
		};

		jQuery(".cme-infolayer-authoreditors ul").each(function(i, ele){ //double check that they authors has the right class
			if(!jQuery(this).hasClass("cme-infolayer-author")){
				jQuery(this).addClass("cme-infolayer-author");
				jQuery(this).find(".imageOuterContainer").removeClass("imageOuterContainer");
				jQuery(this).find(".imageContainer").removeClass("imageContainer");
			}
		});
		
		jQuery('.cme-footer .supporting_links li').each(function(){
		    if(jQuery(this).text().indexOf('References')>-1){
		        var clickVal = jQuery(this).find('a').attr('onclick');
		        var hrefVal = jQuery(this).find('a').attr('href');
		        jQuery("a[onclick=\"wmdPageLink('vwart-refs');\"][href=\"javascript:pop_layer('references_layer');\"]").each(function(){
					jQuery(this).attr({onclick:clickVal, href:hrefVal});
				});
		    }
		});

		//  Add client and wcode (additional parameters) to Login Header link in Medscape.org
		$('.cme-action-loginToStart').each(function(i){
			let splittedUrl = $(this).attr('href').split('?');
			let newHref = '';	
			if(splittedUrl.length > 1) {		
				newHref = splittedUrl[0] +'?wcode=102&client=205502&scode=msporg&' + splittedUrl[1];
			}
			else{
				newHref = $(this).attr('href') + '?wcode=102&client=205502&scode=msporg';
			}	    
			$(this).attr('href', newHref);
		});
});  //end document.ready


// Lazy load the images with data-src attribute
function lazyLoadImages(){
	var lazyLoad_images = $('.lazyLoadImg');
	for(var i=0;i<lazyLoad_images.length;i++){
		$(lazyLoad_images[i]).attr('src', $(lazyLoad_images[i]).attr('data-src'));
	}
}

//video check class add
var cmeVideoCheck = function(){
	var flashVideoCheck = flashVideoCheck || jQuery(".cme-bodyleft object").length;
	var html5VideoCheck = html5VideoCheck || jQuery(".cme-bodyleft video").length;
	var cmeVideoEleCheck = cmeVideoEleCheck || jQuery("#cme-video-player").length;

	//add hasVideo to body if object or video tags are in the left column
	if(flashVideoCheck || html5VideoCheck || cmeVideoEleCheck){
		if(flashVideoCheck >= 1 || html5VideoCheck >= 1 || cmeVideoEleCheck >= 1){
			jQuery("body").removeClass("has-video");
			jQuery("body").addClass("has-video");
		}
	}
}

//clone current activity container
var createStartActivitySticky = function(){
    startActivitySticky = jQuery(".cme-action-startActivity").parent().clone();
    jQuery(startActivitySticky).addClass("startActivitySticky");
    jQuery(".cme-infolayer-container").prepend(startActivitySticky);
}
var maintainActvityBarWidth = function(){
	var containerWidth = jQuery(".cme-infolayer-container").width();
	jQuery(startActivitySticky).width(containerWidth);
}

var setHeaderBackgroundImage = function(){
	var pageHeader = jQuery(".cme-header-container");
	var infoHeader = jQuery(".cme-infolayer-header");
	var imgUrl =  jQuery(pageHeader).data("bgimage");

	if(pageHeader.hasClass("has-bgimage") && imgUrl != undefined && imgUrl != ""){
		var bgImgStyles = { "background-image":"url("+imgUrl+")" }
		pageHeader.css(bgImgStyles);
		infoHeader.addClass("has-bgimage").css(bgImgStyles);
		jQuery("#cme-infolayer-xclose-container").addClass("has-bgimage");
		pageHeader.addClass("has-bgimage");
		infoHeader.addClass("has-bgimage");
	}
}

jQuery(window).on("resize", function(){
	maintainActvityBarWidth();
});


// Supporter Badge Rotation
function nextsupporterlogo() {
	loadsupporterlogo(supporterlogos[currentlogo]);
	if (currentlogo < (supporterlogos.length - 1)) {
		currentlogo = currentlogo + 1;
	} else {
		currentlogo = 0;
	}
}

function loadsupporterlogo(imagepath) {
	$("#supporter_logo").attr("src", imagepath);
	$("#supporter_logo_accme").attr("src", imagepath);
}

/*
// Slideshow Transcript Nav
function next_slide() {
	$('#next_btn').css("visibility", "hidden");
	current_slide = (current_slide * 1) + 1;
	window.location.hash = current_slide;
	var joffset = $("#slide_col").position();
	window.scrollTo(0,joffset.top);
	document.getElementById('slide_nav_bar').style.top = (window.pageYOffset + window.innerHeight - 42) + 'px';
}

function prev_slide() {
	$('#prev_btn').css("visibility", "hidden");
	current_slide = (current_slide * 1) - 1;
	window.location.hash = current_slide;
	var joffset = $("#slide_col").position();
	 window.scrollTo(0,joffset.top);
	document.getElementById('slide_nav_bar').style.top = (window.pageYOffset + window.innerHeight - 42) + 'px';
}

function showQslide(qsnum) {
	var qnum = $('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().substring($('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().indexOf("thequestion") + 11, $('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().indexOf("thequestion") + 12);
	if (qgates[qnum] == "false") {
		if (isAnswered(qids[qnum]) == "true") {
			answergridtotarget('thequestion' + qnum, 'vbar', qids[qnum], 'F:F:F:F');
			$("#submitbutton" + qnum).remove();
			qgates[qnum] = "true";
		} else {
			makesubmitbutton('submitbutton' + qnum, 'answergridtotarget("thequestion' + qnum + '","vbar","' + qids[qnum] + '","F:F:F:T");')
			questiontotarget('thequestion' + qnum, qids[qnum]);
			qgates[qnum] = "true";
		}
	}
							$("#slide_col").css("height","270px");
	var offset = $("#slide_col").offset();
	$('#slide_list .slide_sec:nth-child(' + qsnum + ')').show();
	$('#slide_list .slide_sec:nth-child(' + qsnum + ')').css("position", "absolute");
	$('#slide_list .slide_sec:nth-child(' + qsnum + ')').css("top", offset.top + 5);
	$('#slide_list .slide_sec:nth-child(' + qsnum + ')').css("left", offset.left + 5);
}
// Hide Body of Article, Header and Footer for englare
function togBod() {
	$('#edu_article').toggle();
	$('#medscapeheadercontainer').toggle();
	$('#medscapefooter').toggle();
	$('#theme_nav').toggle();
	$('#contab').toggle();
}

// Pop Layer Function
/*
function pop_layer2(layerid) {
	$('#page_cover').toggle();
	$('#' + layerid).toggle();
	if (layerid == "table_layer") {
		$.each($('#' + layerid + ' .hidden_table'), function() {
			$(this).hide();
		});
	}
}
*/

/*
// CV Network Join the Discussion Link handler
function joindiscuss(disurl) {
	$('#join_dis_iframe').attr('src',disurl);
	joindis_toggle();
	$('#joindis_layer').css("top",($(window).scrollTop()+20)+"px");
}
// Discussion Layer toggle
function joindis_toggle() {
	//$('#page_cover').toggle();
	$('#joindis_layer').toggle();
}
*/

/*
// ACCME Layer
function accme_toggle() {
	//$('#btn_cme_activity').attr('style','top:0');
	//$('#page_cover').toggle();
	$('#cme-infolayer-bg, #accme_layer').toggle();
	window.scrollTo(0,0);
	$('#slide_nav_bar').show();

	if($("#cme-infolayer-bg").css("display")=="none") {
		$("body").css("overflow", "initial");
	}
	else if ($('#new_pdp_page').length > 0) {
		$("body").css("overflow", "initial");
	}
	else {
		//$("body").css("overflow", "hidden");
	}

	/*
        // Hack for replacing instances of 70% passing score in the AACME layer with 75%
        var str=document.getElementById("accme_layer").innerHTML;
        var n=str.replace("you must receive a minimum score of 70% on the post-test.<br>","you must receive a minimum score of 75% on the post-test.<br>");
        document.getElementById("accme_layer").innerHTML=n;
        */
//}

/* Function For Enlarging Imgs
function enlarge_img(img_path) {
	//$('#page_cover').toggle();
	$('#enlarged_img').attr("src", img_path);
	$('#enlarged_img_caption').html(img_cap);
	setTimeout(function() {
		var sImg = $("#enlarged_img");
		var tImg = new Image();
		tImg.src = sImg.attr("src");
		var img_w = tImg.width;
		if (img_w < 962) {
			$('#enlarged_img_caption').css('width', img_w + 'px');
		}
		$('#img_layer').toggle();
		if (document.getElementById("injected_header")) {
			$('#img_layer').css("top", ($(window).scrollTop() + 15) + "px");
		} else {
			$('#img_layer').css("top", ($(window).scrollTop() + 45) + "px");
		}
	}, 500);
}
*/

/* Function For Showing Hidden Slide */
function showslide(state, layerid) {
	if (document.getElementById) {
		//$('#page_cover').toggle();
		var contentlayer = document.getElementById(layerid);
		setElementClass(contentlayer, state);
		if (document.getElementById("injected_header")) {
			$('#' + layerid + ' .layerbg').css("top", ($(window).scrollTop() - 310) + "px");
		} else {
			$('#' + layerid + ' .layerbg').css("top", ($(window).scrollTop() + 45) + "px");
		}
	}
}

/* Function For Showing Hidden Slide */
function showslide2(state, layerid) {
	togBod();
	if (state == "active") {
		if (document.getElementById("mob_slide_con")) {
			$('#mob_slide_con').empty();		
			$('#mob_slide_con').html($('#'+layerid).html());
		}
		else {
			$('#bodypadding').prepend("<div id=\"mob_slide_con\"></div>");
			$('#mob_slide_con').html($('#'+layerid).html());
		}
	}
	else {
		$('#mob_slide_con').empty();		
	}
}


/* Function For Showing Hidden Table
function enlarge_table(tab_id) {
	//$('#page_cover').toggle();
	$('#' + tab_id).show();
	$('#table_layer').toggle();

	if (document.getElementById("injected_header")) {
		$('#table_layer').css("top", ($(window).scrollTop() - 15) + "px");
	} else {
		$('#table_layer').css("top", ($(window).scrollTop() + 45) + "px");
	}
}
*/

// Virtual Page Tracking
function BItrack(thisURL) {
	window.xmlFrame.getFile("desturl=" + trackurl + "%5f" + thisURL);
}

//Function for swapping the lable and the url of the documentum Earn Cme Credit button
function changeButton(href,label) {
	// get any button that has the QNA processor link
	var $cme_btn = $("a.cme_btn[href^=\"/qna/processor\"]");
	if(!$cme_btn || $cme_btn.length == 0)
		return;
	//Adding an additional check to target the "Earn CME button since we don't want this to hijack the "cme info" layer button once the article expires & "earn cme" button automatically gets removed
	var lastBtnText = $cme_btn.text();
	if (lastBtnText.toLowerCase().indexOf("earn") >= 0) {
		if(href){ $cme_btn.attr({"href":href}); }
		//if(label){ $cme_btn.text(label); }
	}
}

//Function to hide the earn cem credit button until a set time
function minutesToButtonShow(minutes){
	if(!minutes){ minutes = 0; }
	$(".cme_btn:last").css({"visibility":"hidden"});
	setTimeout(function(){
		$(".cme_btn:last").css({"visibility":"visible"});
	},minutes * 60 * 1000);
}

//functions for referral buttons
function fburl() {
	wmdPageLink('ar-share_face');
	var fbtitle = document.title;
	var fblink = window.location;
	fblink = fblink + "?src=stfb"
	var fbsharelink = "//www.facebook.com/share.php?u=" + fblink + "&t=" + fbtitle;
	window.open(fbsharelink);
}
function twiturl() {
	wmdPageLink('ar-share_twit');
	var twtitle = document.title;
	var twiturl = window.location;
	twiturl = twiturl + "?src=sttwit"
	var ftwiturl = "//twitter.com/share?url="+twiturl+"&text="+twtitle
	window.open(ftwiturl);
}

function googleurl() {
	wmdPageLink('ar-share_google');
	var ggtitle = document.title;
	var googleurl = window.location;
	googleurl = googleurl + "?src=stgoogle"
	var ftgoogleurl = "https://plusone.google.com/_/+1/confirm?url="+googleurl+"&title="+ggtitle
	window.open(ftgoogleurl);
}

function emailurl() {
	wmdPageLink('ar-share_email');
}

function adexFormSubmit(aformId, atarget, errtarget, awaitdiv, pref, postf) {
	if (pref) {
		pref();
	}
	toggleDisplay(awaitdiv, "block");
	var aform = "#" + aformId;
	var options = {
		type : "POST",
		dataType : "xml",
		success : function(r, s) {
			var status = $(r).find("status").text();
			var page = $(r).find("page").text()
			if (postf) {
				postf(atarget, errtarget, awaitdiv, status, page);
			} else {
				handleFormSubmit(atarget, errtarget, awaitdiv, status, page);
			}
		}
	}
	$(aform).ajaxSubmit(options);
	return false;
}

function adexFormSubmitHTML(aformId, atarget, errtarget, awaitdiv, pref, postf) {
	if (pref) {
		pref();
	}
	toggleDisplay(awaitdiv, "block");
	var aform = "#" + aformId;
	var options = {
		type : "POST",
		success : function(r, s) {
			var page = r;
			var status = 1;
			if (postf) {
				postf(atarget, errtarget, awaitdiv, status, page);
			} else {
				handleFormSubmit(atarget, errtarget, awaitdiv, status, page);
			}
		},
		complete : function(r, s, y) {
			//alert("complete\n" + r);
			if (r.status.toString()[0] == '3') {
				//alert( r.getResponseHeader('Content-Type'));
				//alert( r.getResponseHeader('Date'));
				//alert( r.getResponseHeader('Location'));
				//alert( r.getAllResponseHeaders());
				top.location.href = document.getElementById("loginurl").value;
			}
		},
		error : function(r, s, y) {
			//alert("error\n" + r);
			if (r.status.toString()[0] == '3') {
				//alert( r.getResponseHeader('Location'));
				//alert( r.getAllResponseHeaders());
				//top.location.href = r.getResponseHeader('Location');
			}
		}
	}
	$(aform).ajaxSubmit(options);
	return false;
}

function togglealloff(a) {
}

/* (END) Legacy Functions from adex.js */
/* (START) Legacy Functions from view.js */
/* Show The Email Tool */
function showemailtoolbox(state) {
	if (document.getElementById) {
		var arttool = document.getElementById("emailadexbox");
		if (arttool != null) {
			setElementClass(arttool, state);
			movelayers("emailadexcontainer");
		}
	}
}

/* Confirm Sent Email */
function confirmsent(status) {
	if (document.getElementById) {
		if (status != 1) {
			var arttool = document.getElementById("emailthiserror");
			setElementClass(arttool, 'active');
			return false;
		} else {
			var arttool = document.getElementById("emailconfirmation");
			setElementClass(arttool, 'active');
			var arttool2 = document.getElementById("emailthiserror");
			setElementClass(arttool2, 'inactive');
			var arttoolform = document.getElementById("emailform");
			setElementClass(arttoolform, 'inactive');
			socialCp("emailthis");
			return false;
		}
	}
}

/* Show The Submit Q Tool */
function showsubmitqtoolbox(state) {
	if (document.getElementById) {
		var arttool = document.getElementById("submitadexbox");
		if (arttool != null) {
			setElementClass(arttool, state);
			movelayers("submitadexcontainer");
		}
	}
}

/* Confirm Sent Submit Q */
function confirmsent2(state) {
	if (document.getElementById) {
		if (document.getElementById("Email").value == "") {
			var arttool = document.getElementById("submitqerror");
			setElementClass(arttool, state);
			return false;
		} else {
			var arttool = document.getElementById("submitqconfirmation");
			setElementClass(arttool, state);
			var arttool2 = document.getElementById("submitqerror");
			setElementClass(arttool2, 'inactive');
			var arttoolform = document.getElementById("submitqform");
			setElementClass(arttoolform, 'inactive');
			return false;
		}
	}
}

function showemailbox() {
	showsubmitqtoolbox('inactive');
	showemailtoolbox('active');
	movelayers('emailadexcontainer');
}

function showsubmitbox() {
	showemailtoolbox('inactive');
	showsubmitqtoolbox('active');
}

function processEmailFormResponse(atarget, errtarget, awaitdiv, status, pageHTML) {
	handleFormSubmit(atarget, errtarget, awaitdiv, status, pageHTML);
	confirmsent(status)
}

function processSubmitThisResponse(atarget, errtarget, awaitdiv, status, pageHTML) {
	handleFormSubmit(atarget, errtarget, awaitdiv, status, pageHTML);
	submitthisconfirmsent(status)
}

/* Confirm Sent Email */
function submitthisconfirmsent(status) {
	if (document.getElementById) {
		if (status != 1) {
			var arttool = document.getElementById("submitqerror");
			setElementClass(arttool, 'active');
			return false;
		} else {
			var arttool = document.getElementById("submitqconfirmation");
			setElementClass(arttool, 'active');
			var arttool2 = document.getElementById("submitqerror");
			setElementClass(arttool2, 'inactive');
			var arttoolform = document.getElementById("submitqform");
			setElementClass(arttoolform, 'inactive');
			return false;
		}
	}
}

/* (END) Legacy Functions from view.js */
/* (START) Legacy Functions from cme-helper.js */
function check(ths, checkname, noofcorrect) {
	var totalselected = 0;
	if (ths.checked) {
		for ( i = 0; i < document.questionForm.length; i++) {
			e = document.questionForm.elements[i];
			if (e.type == "checkbox") {
				var c = e.name;
				var d = c.indexOf(checkname);
				if (c == checkname && e.checked == true) {
					totalselected++;
				}
			}
		}
		if (totalselected > noofcorrect && noofcorrect > 0) {
			if (noofcorrect == 1) {
				alert("Only " + noofcorrect + " Correct Answer can be selected");
			} else {
				alert("Only " + noofcorrect + " Correct Answers can be selected");
			}
			ths.checked = false;
		}
	}
}

/* (END) Legacy Functions from cme-helper.js */

//////////////////////////
// new cme functionality

(function($){

	/////////////////////////////////////
	// defines the info layer namespace
	infolayer = {
		$layerdiv: null,
		$body: null,

		init: function () {
			var self = this;
			this.$layerdiv = $("#cme-infolayer-bg");
			if(!this.$layerdiv || this.$layerdiv.length <= 0)
				return;

			this.$body = $("body");
			this.$layerdiv.delegate(".cme-infolayer-xclose, .cme-action-startActivity", "click", function(e) {
				e.preventDefault();
				self.hide();
			}); // end click()
			
			if(typeof isConsultCME == 'undefined') {  //if article redirected from consult, do not show info layer PPE-101829
				// execute some rules to show the info layer on load
				this.replaceInfoLayer70PassingScoreWith75();
				this.showInfoLayerIfDisplayCookieIsSet();
				this.showInfoLayerIfActivityExpired();
			} else {
				$('.last').css('display', 'none');
			}	

		}, // end init()

		show: function () {
			$(".modal-layer-bg").hide(); // hide any modal layers that are showing
			this.$layerdiv.show();

			if ($('#new_pdp_page').length > 0) {
				$("body").css("overflow", "initial");
			}
			else {
				this.$body.css("overflow", "hidden");
			}
		}, // end show()

		hide: function () {
			this.$layerdiv.hide();
			this.$body.css("overflow", "auto");
			$(document).trigger("hide-info-layer");
		}, // end hide()

		//////////////////////////
		// cme info layer rules
		replaceInfoLayer70PassingScoreWith75: function () {
			// Hack for replacing instances of 70% passing score in the info layer with 75%
			//var str = document.getElementById("cme-infolayer-bg").innerHTML;
			//var n = str.replace("you must receive a minimum score of 70% on the post-test.<br>", "you must receive a minimum score of 75% on the post-test.<br>");
			//document.getElementById("cme-infolayer-bg").innerHTML = n;
			if($(".cme-infolayer-content").length > 0) {
				var str = $(".cme-infolayer-content").html();
				str = str.replace("you must receive a minimum score of 70% on the post-test.<br>",
						"you must receive a minimum score of 75% on the post-test.<br>");
				$(".cme-infolayer-content").html(str);
			} // end if
		}, // end replaceInfoLayer70PassingScoreWith75()

		showInfoLayerIfDisplayCookieIsSet: function () {
			// ACCME check - on page load show if true or keep hidden if false
			if ($('input[name="displayAccme"]').val() == "true" &&
					$("#cme-infolayer-bg").length != 0 &&
					$('.disableAccmeOverlay').length === 0) {
				this.show();
			} // end if
		}, // end showInfoLayerIfDisplayCookieIsSet()

		showInfoLayerIfActivityExpired : function(){
			// Replace "AACME check" with "true" when the article is expired.
			if ($(".has-expired").length > 0) {
				var self = this;
				var $localeOpo = $('input[name="localeFromOtherPage"]').val();
				if ($localeOpo == undefined || $localeOpo == "null" || $localeOpo == "en_us") {
					self.show();
				}
			}
		} // end showInfoLayerIfActivityExpired()
	}; // end infolayer

	/////////////////////////////////////
	// defines the modal layer namespace
	modallayer = {
		$body:null,

		init: function() {
			var self = this;
			this.$body = $("body");
			// generate a generic layer to show content in
			self.createGenericModalLayerHTML();
			$(".modal-close").click(function(e){
				e.preventDefault();
				self.hide();
			}); // end click()
			//self.formatAbbreviationsContent();
		}, // end init()

		show: function(modallayerid, strclassname) {
			var $layer = $("#"+modallayerid);
			if(!$layer || $layer.length == 0)
				return;
			if(strclassname)
				$layer.addClass(strclassname);
			$layer.show();
			this.$body.css("overflow", "hidden");
			//var device = DFPTargetKeys.reqHeaders.device;
			//if(device === "IPAD" || device === "MOBILE") {
			//	this.bodyPosition = this.$body.css("position");
			//	this.bodyScrollTop = this.$body.scrollTop();
			//	this.$body.css("position", "fixed");
			//	this.$body.css("top", "-" + this.bodyScrollTop + "px");
			//}
		}, // end show()

		// shows a modal layer with content
		showContent: function(strtitle, strcontent, strclassname) {
			if(strtitle == null || strtitle == "")
				return;
			$("#generic_modal_layer .modal-header h6 .modal-title").html(strtitle);
			$("#generic_modal_layer .modal-content").html(strcontent);
			// show the generic modal layer
			this.show("generic_modal_layer", strclassname);
		}, // end showContent

		hide: function() {
			$(".modal-layer-bg").hide();
			this.$body.css("overflow", "auto");
			//var device = DFPTargetKeys.reqHeaders.device;
			//if(device === "IPAD" || device === "MOBILE") {
			//	this.$body.css("position", this.bodyPosition);
			//	this.$body.scrollTop(this.bodyScrollTop);
			//}
			$(document).trigger("hide-modal-layer");
		}, // end hide()

		formatAbbreviationsContent: function() {
			var $content = $("#abbreviations_layer .modal-content")
			if(!$content || $content.length <= 0)
				return;
			var html = $content.html();
			var abbr = html.split('\n');
			for(var i=0; i<abbr.length; i++){
				abbr[i] = abbr[i].trim();
				if(abbr[i].length == 0)
					continue;
				abbr[i] = "<li>" + abbr[i] + "</li>";
			} // end for

			html = "<ol>" + abbr.join("") + "</ol>";
			$content.html(html);
			return;
		}, // end formatAbbreviationsContent()

		createGenericModalLayerHTML: function() {
			var $modal_layer = $("#references_layer, #author_layer");
			if($modal_layer == null || $modal_layer.length == 0)
				return;
			var $layer = $($modal_layer[0]).clone();
			$layer.attr("id", "generic_modal_layer");
			$layer.find(".modal-header h6").html("<span class=\"modal-title\"></span></span><span class=\"modal-close\"><a href=\"#\"></a></span>");
			$layer.find(".modal-content").html("");
			$modal_layer.after($layer);
			return;
		}, // end createGenericModalLayerHTML()
	}; // end modallayer

	///////////////////////////////////
	// rotating support badge
	supportedbadges = {
		init: function(sel) {
			var $containers = $(sel);
			$containers.each(function(i, container){
				var $logos = $(container).find("img");
				var frames = $logos.length;
				if(frames <= 0)
					return;

				// show the first
				$($logos[0]).addClass("active");
				if(frames <= 1)
					return;

				var currentlogo = 0;
				setInterval(function(){
					$logo = $($logos[currentlogo]);
					$logo.removeClass("active");
					currentlogo++;
					currentlogo = (currentlogo >= frames) ? 0 : currentlogo;
					$logo = $($logos[currentlogo]);
					$logo.addClass("active");
				}, 3000);
			}); // end each()
			return;
		} // end init()
	}; // end supportedbadges

	///////////////////////////////////////////
	// defines the slideshow player namespace
	slideshow2 = {
		$iframe: null,
		iframe_window: null,
		iframe_questions: null,
		$iframe_slidecol: null,

		init : function() {
			var self = this;
			var $iframe = $(".org_content_iframe");
			this.iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;

			// check if the slideshow iframe exist
			if($iframe.length < 1)
				return;

			this.$iframe = $iframe;

			// make sure the iframe points to same domain in order to prevent CORS and
			// to allow the parent window to manipulate the iframe's DOM
			this.ensureSameDomain();

			// get the container element of the iframe
			$iframe.parent().addClass("cme-slideshow-container");

			// indicate that this article contains a slideshow
			$("body").addClass("cme-slideshow-page")

			// check when the iframe has loaded
			this.$iframe.load(function() {
				var iframe_window = this.contentWindow;
				var iframe_document = iframe_window.document;

				// cache the iframe window object
				self.iframe_window = iframe_window;

				// check for hash changes and when the slides change
				// the slideshow changes sizes whenever user clicks next and prev
				$(iframe_window).on("hashchange", function(e) {
					self.resize();
				}); // end hashchange

				// check for doc ready event to load addition css files
				// and move the questions in the iframe's DOM
				$(iframe_document).ready(function() {
					// make the iframe get it's responsive styles from edu-article.css
					self.loadCSSFile();

					// make sure the questions are loaded in the slideshow container
					// this makes them easy to make responsive
					self.loadQuestions();

//					alert("delegating image");
//					$slide_col = $(iframe_document).find("#slide_col");

//					if($slide_col.length>0)
//						alert("got the slide_col");

					//.on("load", "img" ,function() {
						/* Fire your image resize code here */
//						console.log("resize");
//						alert("loaded");
				//	});
				}); // end ready



				// resize the iframe and it's contents during window resizes
				$(window).resize(function() {
					self.resizeToFitContents();
				}); // end resize

				// resize the iframe after closing and model layers on the page
				$(document).on("hide-modal-layer, hide-info-layer", function(){
					self.resize();
				}); // end on

				// show the iframe and resize it again after a half second
				self.$iframe.show();
				self.delayedResize(500);
			}); // end on()
		}, // end init()

		// resize the slideshow by triggering a resize event
		resize : function() {
			$(window).trigger("resize");
		}, // end resize()

		// do resizing after several seconds
		delayedResize : function(ms){
			var self = this;
			setTimeout(function(){
				self.resize();
			}, ms);
		}, // end delayedResize()


		isInitialized : function() {
			return (this.$iframe && this.$iframe.length>0);
		}, // end exist()

		// ensuring the iframe points to the right environment prevents CORS errors and
		// allows this code to manipulate the iframe's DOM
		ensureSameDomain : function() {
			var iframe = this.$iframe[0];
			var env = DFPTargetKeys.reqHeaders.requestEnv;
			var src = iframe.src;
			if(src.indexOf(env) == -1) {
				iframe.src = src.replace("www.medscape.org", "www." + env + ".medscape.org");
			} // end if
			return;
		}, // end ensureSameDomain()

		loadCSSFile : function(){
			var env = DFPTargetKeys.reqHeaders.requestEnv;
			var device = DFPTargetKeys.reqHeaders.device;
			var $body = $(this.iframe_window.document.body);
			var head = this.iframe_window.document.head;
			var linkattrs = {type: 'text/css', rel: 'stylesheet'};
			var self = this;

			// update the environment variable
			env = (env !== "") ? env + "." : "";

			// label the iframe's body with this class
			$body.addClass("cme-slideshow");	// tag the body

			// erase the inline styles of the nav bar
			$body.find("#slide_nav_bar2").attr("style","");

			this.$iframe.addClass(device);

			// check if not showing slideshow on a PC
			if(device !== "PC") {
				$body.addClass("mobile"); // change this to cme-mobile
				linkattrs.href = '//img.medscape.com/medcss/1024/cme/slideshow/edu-article-styles-ss.css';
				$('<link>').appendTo(head).attr(linkattrs);
			} // end if
			else  {
			//	this.$iframe.css("width", "100%");
			} // end else

			//alert(device);

			// add the responsive styles to the iframe
			linkattrs.href = '//img.' + env + 'medscapestatic.com/medscape-core/cme/css/article/edu-article.css';
			$('<link>').appendTo(head).attr(linkattrs);
			return;
		}, // end loadCSSFile()

		loadQuestions : function() {
			var self = this;
			var $body = $(this.iframe_window.document.body);
			var $slide_player = $body.find("#slide_player");

			if($body.length < 1 || $slide_player.length < 1)
				return;

			// append a container to hold the question in the player
			$slide_player.append("<div id='slide_ques_col'></div>");

			// get the slidecol and slidequescol elements
			self.$iframe_slidecol = $slide_player.find("#slide_col");
			self.$iframe_slidequescol = $slide_player.find("#slide_ques_col");

			// get the questions
			self.iframe_questions2 = {};
			$.each($body.find(".slide_sec"), function(i,slide) {
				var $slide = $(slide);
				if($slide.html().indexOf("thequestion") !== -1) {
					var slidequestion = $slide.clone();

					// erase inline styles
					slidequestion.attr("style","");

					// move the slide question
					self.$iframe_slidequescol.append(slidequestion);
					self.iframe_questions2[i] = slidequestion;
				} // end if
				else {
				}
			}); // end each()

			// override the showQuestion function
			self.iframe_window.showQslide = function(qsnum) {
				var iframe_window = self.iframe_window;
				var qnum = iframe_window.$('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().substring(iframe_window.$('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().indexOf("thequestion") + 11, iframe_window.$('#slide_list .slide_sec:nth-child(' + qsnum + ') .slide:last-child').html().indexOf("thequestion") + 12);
				if (iframe_window.qgates[qnum] == "false") {
					if (iframe_window.isAnswered(iframe_window.qids[qnum]) == "true") {
						iframe_window.answergridtotarget('thequestion' + qnum, 'vbar', iframe_window.qids[qnum], 'F:F:F:F');
						iframe_window.$("#submitbutton" + qnum).remove();
						iframe_window.qgates[qnum] = "true";
					} else {
						iframe_window.makesubmitbutton('submitbutton' + qnum, 'answergridtotarget("thequestion' + qnum + '","vbar","' + iframe_window.qids[qnum] + '","F:F:F:T");')
						iframe_window.questiontotarget('thequestion' + qnum, iframe_window.qids[qnum]);
						iframe_window.qgates[qnum] = "true";
					}
				}
			};

			return;
		}, // end loadQuestion()

		resizeToFitContents : function() {
			if(!this.isInitialized())
				return;
			var self = this;
			var ssiframe = this.$iframe[0];
			var $ssbody = $(this.iframe_window.document.body);
			var sswindow = this.iframe_window;
			var ssquestions = this.iframe_questions2;
			var $ssslidecol = self.$iframe_slidecol;
			var device = DFPTargetKeys.reqHeaders.device;

			var hash = sswindow.location.hash.split("#");
			hash = parseInt(hash[1]);

			// get and set the current breakpoint classes
			var bp = window.getComputedStyle($(".org_content_iframe")[0], ':after').getPropertyValue('content').replace(/\"/g,'');
			//console.log(bp);
			$ssbody.removeClass(this.bp);
			$ssbody.addClass(this.bp=bp);

			// determine to show the slideshow in one-column layout or default layout
			if(bp !== "BP4")
				$ssbody.addClass("one-column");
			else $ssbody.removeClass("one-column");

			var isquestionslide = hash>0 && ssquestions[hash-1];
			if(isquestionslide) {
				var $ssquestion = ssquestions[hash-1];
				$ssbody.addClass("slide-question");
				$ssslidecol.height($ssquestion.height()+7);
				$ssquestion.width($ssslidecol.width());
				$ssquestion.width($ssquestion.width()-5);
				$ssquestion.find(".slide").css("border","none");
				$ssquestion.find(".slide").css("width","100%");
				$ssquestion.addClass("active");
				$ssquestion.attr("style","");
				self.activessquestion = $ssquestion;
			} // end if
			else {
				if(self.activessquestion)
					self.activessquestion.removeClass("active");
				$ssbody.removeClass("slide-question");
				$ssslidecol.css("height","auto");
				$ssslidecol.find("img").on("load", function() {
					ssiframe.width = $ssbody[0].scrollWidth;
					ssiframe.height = $ssbody.find("#bodypadding").height()+3;
					if(self.iOS) {
						$(ssiframe).css("width", ssiframe.width + "px");
						$(ssiframe).css("height", ssiframe.height + "px");
					}
				}); // end load
			} // end else

			// resize the iframe to fit it's contents
			ssiframe.width = $ssbody[0].scrollWidth;
			ssiframe.height = $ssbody.find("#bodypadding").height()+3;
			if(self.iOS) {
				$(ssiframe).css("width", ssiframe.width + "px");
				$(ssiframe).css("height", ssiframe.height + "px");
			}

			return;
		} // end resizeToFitContents()
	}; // end slideshow

	flashvid = {
		flashvidsize : 933,
		init : function() {
			this.$flashvid = $(".flashvid, #videoLayer");
			this.$flashvidcontainer = $(".flashvidcontainer");
			this.$html5vidbox = $(".html5vidbox");
			this.$video = this.$html5vidbox.find("video");
			var self = this;
			var showflash = false;

			// check if this is the html5 player version
			if (this.$flashvid.find("#cme-video-player").length > 0) {
				$("body").addClass("cme-vid");
				$("body").addClass("has-video");
				return;
			} // end if

			// check if the legacy flash video exist on the page
			if(this.$flashvid.length < 1 || this.$flashvidcontainer.length < 1 || this.$video.length < 1) {
				return;
			} // end if

			// set it to be flash initially
			$("body").addClass("cme-vid");
			$("body").addClass("has-video");

			// disable the video from preloading
			this.$video.attr("preload", "none");

			// check when size of container to do a switch
			$(window).resize(function() {
				// check if time to switch player
				var curshowflash = self.$flashvid.width()>=self.flashvidsize &&
						DFPTargetKeys.reqHeaders.device == "PC";
				if(curshowflash !== showflash) {
					showflash = curshowflash;
					self.switchPlayer(showflash);
				} // end if
			}); // end resize()

			// call resize to do the initial switch
			$(window).resize();
			return;
		}, // end init()

		switchPlayer : function(bFlash) {
			if(bFlash) { // show the flash video
				$("body").addClass("cme-flashvid");
				this.$video[0].pause(); // pause the video if it's playing
			} // end if
			else { // show the html5 video
				$("body").removeClass("cme-flashvid");
			} // end else
		} // end switchPlayer()
	}; // end flashvid

	cmetv = {
		init : function() {
			var self = this;

			// check if the cme-tv input element exist
			var $cmetv = $("input[name=cme-tv]");
			if($cmetv.length === 0)
				return;

			// set it to be flash initially
			$("body").addClass("has-video");

			// check when the cme tv has loaded
			$(document).ajaxSuccess(function(event, xhr, settings) {
				////www.qa02.medscape.org/noscan/features/cme-tv/thrombosis-tv-3/866910?lang=
				if(settings.url.indexOf("cme-tv") !== -1) {
					self.load();
				}; // end if
			}); // end ajaxSuccess()
		}, // end init()

		load : function() {
			var $flashcontainer = $(".flashvidwrapper");

			if(DFPTargetKeys.reqHeaders.device !== "PC" || typeof flashvars === "undefined" || !flashvars
					|| !flashvars.configPath || flashvars.configPath == "" ||
					$flashcontainer.length == 0){
					//cmeVideoCheck();
				return;
				}

			$("body").addClass("has-video");

			var configPath = flashvars.configPath;
			var path = configPath.split('/');
			var articleId = path[9] + "";
			var currYear = path[7];
			var articleSplit = articleId.slice(0,3) + "/" + articleId.slice(3);
			var posterurl = "//img.medscape.com/article/" + articleSplit + "/" + articleId + "_start.png";
			var videourl = "//img.medscape.com/pi/editorial/studio/video/" + currYear + "/education/" + articleId + "/" + articleId + ".mp4";
			var strhtml = '<video poster="' + posterurl + '" src="' + videourl + '" controls></video>';
			var showflash = false;
			var $object = $flashcontainer.find("object");
			var maxwidth = $object.attr("width");
			var $vidouterwrap = $(".vid_outerwrap");

			// add the video url next to the flash player
			$flashcontainer.after("<div class=\"html5vidbox\">" + strhtml + "</div>");

			// resizes the flash video
			$(window).resize(function() {
				// check if time to switch player
				var curshowflash = ($vidouterwrap.width() > maxwidth);
				if(curshowflash !== showflash) {
					if (curshowflash) $("body").addClass("cme-flashvid");
					else $("body").removeClass("cme-flashvid");
					showflash = curshowflash;
				} // end if
			}); // end resize()

			$(window).resize();
			return;
		} // end load()
	}; // end cmetv

	inlinepdf = {
		init : function() {
			// check if article contains pdf content
			var $pdf = jQuery("#inlinePdfChrome, #inlinePdfNonChrome object");
			if(!$pdf || $pdf.length <= 0)
				return;

			// tag the parent with the container class
			var $container = $pdf.parent();
			$container.addClass("inline-pdf-container");
			// $("body").addClass("inline-pdf");

			// check for pdf support
			var mimes = navigator.mimeTypes;
			var PDFsupport = false;
			for (var i = 0, i_len = mimes.length; i < i_len; i++) {
				if (mimes[i].type === 'application/pdf') {
					PDFsupport = true;
					break;
				}
			}

			// show iframe pdf for chrome desktop only
			if (typeof window.chrome === "undefined") {
				if (navigator.userAgent.indexOf('MSIE') != -1 && Number(navigator.userAgent.match(/MSIE \d+/)[0].split(' ')[1]) == 8) {
					jQuery("#inlinePdfChrome").show();
					jQuery("#inlinePdfNonChrome").hide().remove();

				} else {
					jQuery("#inlinePdfChrome").remove();
					jQuery("#inlinePdfNonChrome").show();
				}
			} else {
				//chrome only pdf support check.
				if (PDFsupport === true) {
					jQuery("#inlinePdfNonChrome").remove();
					jQuery("#inlinePdfChrome").show();
				} else {
					jQuery("#inlinePdfChrome").remove();
					jQuery("#inlinePdfNonChrome").show();
				}
			}

			// Provide a clickable layer on embedded pdfs for iPhone 8.3+
			if ($('#inlinePdfNonChrome').length > 0) { //This div id should only appear on sidebar pages that contain pdfs
				var iosVerCheck = function () { //version checking.  This function currently returns "less than 8, 8.0-8.299 or 8.3+"
					var deviceAgent = navigator.userAgent.toLowerCase();

					// check for any ios device
					if (/(iphone|ipod|ipad)/.test(deviceAgent)) {
						if (/(iphone|ipod|ipad).* os 8_0/.test(deviceAgent) || /(iphone|ipod|ipad).* os 8_1/.test(deviceAgent) || /(iphone|ipod|ipad).* os 8_2/.test(deviceAgent)) {
							return "8083" //iOS version 8.0 through version 8.2999
						}
						else {
							return "83plus" //iOS version 8.3 and greater
						}
					}
					else if (/(iphone|ipod|ipad).* os 7_/.test(deviceAgent) || /(iphone|ipod|ipad).* os 6_/.test(deviceAgent)) {
						return "lessthan8" //iOS 6 or 7
					}
				}
				if (iosVerCheck() == "83plus") {
					coverWidth = $('#inlinePdfNonChrome object').css('width');
					coverHeight = $('#inlinePdfNonChrome object').css('height');
					coverSrc = $('#inlinePdfNonChrome object').attr('data');
					$('#inlinePdfNonChrome').prepend('<div id="inlinePdfChromeCover" style="cursor:pointer;position:absolute;height:' + coverHeight + ';width:' + coverWidth + ';">&nbsp;</div>')
					$('#inlinePdfChromeCover').on('click', function () {
						window.location = coverSrc;
					});

					// prevent safari from loading a cached page
					$(window).bind("pageshow", function(event) {
						if (event.originalEvent.persisted) {
							window.location.reload()
						}
					});
				}
			}
		}, // end init()
	}; // end inlinepdf

	govern_compliance_508 = {
		init: function () {
			var $script = $('#cme-508-compliance');
			if (!$script || $script.length == 0)
				return;
			this.injectInfoLayerContent();
			this.removeLayersAndHideLinks();
			this.showExpiredMessage();
			this.addAltTag();
			$("body").css("overflow", "auto");

			// override the compliance 508 function to suppress js error
			window.compliance508 = function () {
			}
		}, // end init()

		injectInfoLayerContent: function () {
			// inject cme info into div identified as cmeinfoadd
			var $cmeinfoadd = $("#cmeinfoadd");
			if (!$cmeinfoadd || $cmeinfoadd.length == 0)
				return;
			var $infolayercontent = $("#cme-infolayer-bg .cme-infolayer-content");
			if (!$infolayercontent || $infolayercontent.length <= 0)
				return;
			// add alt text to the images pulled in from CME info layer
			$infolayercontent.find(".cme-infolayer-author").each(function (i, author) {
				var $authorname = $(author).find("h3");
				var $authorpic = $(author).find("img");
				if ($authorname && $authorpic && $authorname.length > 0 && $authorpic.length > 0) {
					$authorpic.attr("alt", $authorname.text());
				} // end if
			});
			$cmeinfoadd.html("<h2 class='cme-information'>CME Information</h2><div class='cme-infolayer-content'>" + $infolayercontent.html() + "<div>");
		}, // end injectInfoLayerContent()

		showExpiredMessage: function () {
			// check if the article expired
			var $supportbadge = $(".supporter_badge_accme img, .cme-infolayer-supportedby img");
			if (!$supportbadge || $supportbadge.length <= 0)
				return;

			// show expired message
			if ($(".has-expired").length != 0) {
				var strmsg1 = "The accredited provider can no longer issue certificates for this activity. Medscape cannot attest to the timeliness of expired CME activities.";
				var strmsg2 = "Moreover, because statutes, regulations, and policy information may change over time, the information available in this course may be out-of-date.  If you need additional information concerning CMS programs, we recommend that you access <a href='//www.cms.gov' target='_blank'>www.cms.gov</a>.</p>";

				$cmeinfo = $(".cme-information");
				$cmeinfo.after("<div id='cms_expired_info'></div>");
				$cms_info = $("#cms_expired_info");
				$cms_info.append("<p>" + strmsg1 + "</p>");
				$supportbadge.each(function (i, img) {
					if ($(img).attr("src").indexOf("cms") > 0) {
						$cms_info.append("<p>" + strmsg2 + "</p>");
						return false;
					} // end if
				});
			} // end if

			// add long description to supporter badge
			var $supportertext = $("#supportertext");
			if ($supportertext && $supportertext.length >= 0)
				$supportbadge.attr("alt", $supportertext.val());

			// Adds pixel link below the body for skipping navigation
			var anchorlinkfor508 = $('link[rel=canonical]:eq(0)').attr('href') + "#contentstart";
			$("body").prepend('<div style="position:absolute;" style="background-color:#FFFFFF;"><a href="' + anchorlinkfor508 + '" target="_self"><img alt="Skip to start of content" src="//img.medscape.com/images/contentstart.png" width="1" height="1" border="0" /></a></div>');
			$("#edu_article_content").prepend('<a name="contentstart"></a>');
			// Add alt text to previous, next and Earn CME Credit navigation buttons
			$('#next_page_nav a').attr('alt', 'Next Page');
			$("#next_page_nav a:contains('Credit')").attr("alt", "Earn CME Credit");
			$('#prev_page_nav a').attr('alt', 'Previous Page');
			// Adds a description to the title tag of incorrectly answered questions
			$('.incorrectquestion').attr('title', function () {
				return 'this question was answered incorrectly';
			});
		}, // end showExpiredMessage()

		addAltTag : function () {
			$("[alt-text]").each(function(){
				$(this).attr("alt",$(this).attr("alt-text"));
			});
		}, // end addALTTag()

		removeLayersAndHideLinks : function() {
			$(".cme-infolayer-bg").remove();
			$("#author_layer").remove();
			$("#references_layer").remove();
			$("#joindis_layer").remove();
			$("#abbreviations_layer").remove();

			//src$="508-compliance.js"
			//var $script = $('script[src$="508-compliance.js"]');
			$("a[href^=\"javascript:pop_layer\"], a[href^=\"javascript:accme_toggle\"]").hide();
		} // end removeLayers
	} // end govern_compliance_508

	practicechallenge = {
		init : function() {
			// check article if article has practice challenge script
			$script = $('script[src$="user-functions.js"], script[src$="user-functions2.js"]');
			if(!$script || $script.length == 0 || $script.attr("src").indexOf("practice-challenge") <= -1)
				return;

			// get the script src
			var ufsrc = $script.attr("src");

			// ensure the script points to right environment
			var env = DFPTargetKeys.reqHeaders.requestEnv;
			if(ufsrc.indexOf(env) == -1) {
				ufsrc = ufsrc.replace("img.medscapestatic.com", "img." + env + ".medscapestatic.com");
			} // end if

			// override pop_image function
			if(window.pop_image && typeof window.pop_image == "function") {
				window.pop_image = function(b, c) {
					var $link = $("#"+b);
					$link.on("click", function(e) {
						e.preventDefault();

						var $link = $(this);
						var titlehtml = "";
						if ($link.find("#magglass").length > 0)
							titlehtml = $link.next().html();
						else
							titlehtml = $link.html();

						$img = $link.parent().find("img");
						var contenthtml = '<img src="'+$img[0].src+'" />';
						modallayer.showContent(titlehtml, contenthtml, "prac-challenge-popup transcipts-popup");
					}); // end .clicks
				} // end function()
			} // end if

			// override tablePOP function
			if(window.tablePOP && typeof window.tablePOP == "function") {
				window.tablePOP = function (fileIDX, title, width, height, secID) {
					$table = $('#' + secID);
					if (!$table || $table.length == 0)
						return;
					var contenthtml = $table.html();
					var $title = $table.find("p strong");
					var titlehtml = (!$title || $title.length === 0) ? "&nbsp;" : $title.text().trim();
					modallayer.showContent(titlehtml, contenthtml, "prac-challenge-table-popup, transcipts-popup");
				} // end tablePOP()
			} // end if

			// override the
			var prevonallsectionload = window.onallsectionload;
			window.onallsectionload = function() {
				prevonallsectionload();
				var buildcomparetohide=String(myJSONgroupingINT.length-1)+'_'+String(myJSONgroupingINT[myJSONgroupingINT.length-1].idx.length-1)
				if(lasthash==buildcomparetohide){$('#content_types,.cme_btn:eq(0)').show();} else {$('#content_types,.cme_btn:eq(0)').hide();}
				$('#content_types,.cme_btn:eq(1)').show();
			} // end onallsectionload

			$(window).on("hashchange", function(e) {
				var $top = $("#tabs")
				if($top.length>0)
				    $top[0].scrollIntoView();
			}); // end hashchange

		}, // end init()
	} // end practicechallange

	emailthispopup = {
		init : function() {
			var self = this;

			// remove the html in the span tag. Not seen for this design per zeplin
			//$(".email_func span").html("");
			//alert("hello, world");

			//override
			window.adexGet = function(formurl, atarget, awaitdiv, pref, postf) {
				self.showPopupLayerWithForm(formurl);
			}; // end adexGet()

			window.adexFormSubmit = function(aformId, atarget, errtarget, awaitdiv, pref, postf) {
				self.handleSubmit(aformId);
			}; // end adexFormSubmit
		}, // end init()

		showPopupLayerWithForm : function(url) {
			var self = this;
			var strhtml = "<div class=\"error\"></div>";
			var strhtml = "<div class=\"wait\">Processing....</div>";
			strhtml += "<div class=\"content\"></div>"

			// show the modal layer
			modallayer.showContent("Email This", strhtml, "emailthis-popup");

			// save the content area to render the form
			var $modalcontent = $(".emailthis-popup .modal-content");
			self.$content =  $modalcontent.find(".content");
			self.$error = $modalcontent.find(".error");
			self.$wait = $modalcontent.find(".wait");

			// get the form
			$.ajax({
				type: "GET",
				url: url,
				dataType:"html",
				success : function(html) {
					// remove any access spaces in the html
					html = html.replace(/>\s+</g,'><');
					self.$wait.html("");
					self.$content.html(html);
					self.$content.find("b").each(function(i,b){
						$(b).html($(b).html().replace(":",""));
					});

					// get the submit button
					var $submit = self.$content.find(".subbtn input");
					$submit.addClass("cme_btn");

					// get the required input
					var inputs = self.$content.find("#senderName, #recipientEmailAddress, #emailSubject");
					var $textarea = self.$content.find("#emailMsg");


					// add place holder attributes
					$(inputs[0]).prop("placeholder","Name");
					$(inputs[1]).prop("placeholder","Recipient Email");
					$(inputs[2]).prop("placeholder","Subject");
					$textarea.prop("placeholder","Your Message")

					// make fields required
					inputs.attr("required");

					function onchange(e){
						var bdisable = false;
						for(var i=0; i<inputs.length; i++) {
							if($(inputs[i]).val().trim() === "") {
								bdisable = true;
								break;
							} // end if
						} // end for
						$submit.prop("disabled", bdisable);
					} // end onchange()

					onchange();

					// check if the input has a value
					inputs.change(onchange);

					// disable some controls
					if(typeof(pfizFlag) !== 'undefined' && pfizFlag != '') {
						self.$content.find('#emailSubject, #emailMsg').prop("disabled",true);
					} // end if
				}, // end success
				error : function(e) {
					console.log(e);
					self.$wait.html("");
					self.$content.addClass("failure");
					self.$content.html("We're sorry, our system has encountered an error.  Please try again.")
				} // end error
			}); // end ajax
		}, // end showPopupLayerWithForm

		handleSubmit : function(formid) {
			var self = this;
			var $form = self.$content.find("#"+formid)
			var $email = $form.find("#recipientEmailAddress");
			var regex = /^[a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]([a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]||([.]{1,1}[a-zA-Z0-9!#$%^&*_+\-={}'\\|\/?~]))*@([A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9]\.)+[A-Za-z]{2,6}$/;
			var msg	= 'Please enter a valid email address';

			// check if email is valid.
			var validation = new RegExp(regex);
			if (!validation.test($email.val())) {
				$("#emailthiserror").html(msg);
				return;
			} // end if

			// submit the form
			$form.ajaxSubmit({
				type: "POST",
				datatype: "xml",
				success : function(r, s) {
					var status = $(r).find("status").text();
					var pageHTML = $(r).find("page").html();
					if(status == 1) {
						self.$content.html(pageHTML);
						self.$content.addClass("success");
					} // end if
					else {
						self.$content.html(pageHTML);
						self.$content.addClass("failure");
					} // end else

				} // end success
			}); // ajaxSubmit()
		} // end handleSubmit()
	} // end emailthispopup
}($));

// shows the activity layer
function accme_toggle() {
	if ($('.cme-infolayer-container').length > 0) {
		$('#bodypadding').removeClass('actstarted');
		$('.cme-button.cme-action-startActivity').text("Continue Activity");
		$('#cme-infolayer-bg').show();
	}
	
	//infolayer.show();
} // end accme_toggle()

// shows the reference, abbreviations, author layers
function pop_layer(layerid) {
	//var classname = ""
	//if(layerid == "author_layer")
	//	classname = "cme-infolayer-container"
	modallayer.show(layerid);
} // end pop_layer

// shows the slide on the transcipts pages
function showslide(state, layerid) {
	var titlehtml = $("#" + layerid + " h4").html();
	var contenthtml = $("#" + layerid + " blockquote").html();
	modallayer.showContent(titlehtml,contenthtml, "transcipts-popup");
} // end showslide()

// shows the join discussion popup
function joindiscuss(disurl) {
	var disurl = disurl.replace(".perf", "");
	window.open(disurl);
} // end joindiscuss()

// shows the email this popup
function showemailbox() {
	$("#emailadexcontainer").remove();
	var strhtml = "<div id=\"emailadexcontainer\"><div id=\"adexwait\"><p>processing....<p></div><div id=\"emailadexbox\" class=\"active\"></div></div>";
	modallayer.showContent("Email This", strhtml, "discuss-popup");
} // end showemailthispopup()

// shows the popup for transcript images
function enlarge_img(img_path) {
	var $link = $(".fig_table a[href=\"javascript:enlarge_img('"+img_path+"');\"]");
	if(!$link || $link.length === 0)
		return;
	var $title = $link.parent().find(".img_caption b");
	if(!$title || $title.length === 0) {
		$title = $($link.parent().prevAll("h4").get(0));
	} // end if
	var titlehtml = (!$title || $title.length === 0) ? "&nbsp;" : $title.text().trim();
	var contenthtml = "<img src=\""+img_path+"\" />";
	modallayer.showContent(titlehtml,contenthtml, "transcipts-popup");
} // end enlarge_img()

// shows the popup for transcript tables
function enlarge_table(tab_id) {
	$table = $('#' + tab_id);
	if(!$table || $table.length == 0)
		return;
	var contenthtml = $table.html();
	var $title = $table.find(".table_caption"); //$table.find("h4");
	var titlehtml = (!$title || $title.length === 0) ? "&nbsp;" : $title.html().trim();
	modallayer.showContent(titlehtml,contenthtml, "transcipts-popup tables-popup");
} // end enlarge_table()


/* START: Legacy Question Binding & Functions */
$(document).on('click','.qacontainer .answertext12',function(){
	if ($(this).find('input').prop('checked') == false) {
		$(this).find('input').prop('checked', true);
	}
	else {
		$(this).find('input').prop('checked', false);
	}
	
});	
function toggleDisplay(elem, display) {
	if (document.getElementById && document.getElementById(elem)) {
		document.getElementById(elem).style.display = display;
	}
}
function handleFormSubmit(atarget, errtarget, awaitdiv, status, pageHTML) {
	toggleDisplay(awaitdiv, "none");
	if (status == 1) {
		document.getElementById(atarget).innerHTML = pageHTML;
	} else {
		document.getElementById(errtarget).innerHTML = pageHTML;
	}
}
/* END: Legacy Question Binding & Functions */

/*
 * Required for the flash player on cme articles
 * desc: minified swift object
 */
var swfobject=function(){function v(){"complete"==n.readyState&&(n.parentNode.removeChild(n),w())}function w(){if(!r){if(t.ie&&t.win){var a=J("span");try{var b=h.getElementsByTagName("body")[0].appendChild(a);b.parentNode.removeChild(b)}catch(a){return}}r=!0,o&&(clearInterval(o),o=null);for(var c=j.length,d=0;d<c;d++)j[d]()}}function x(a){r?a():j[j.length]=a}function y(b){if(typeof g.addEventListener!=a)g.addEventListener("load",b,!1);else if(typeof h.addEventListener!=a)h.addEventListener("load",b,!1);else if(typeof g.attachEvent!=a)K(g,"onload",b);else if("function"==typeof g.onload){var c=g.onload;g.onload=function(){c(),b()}}else g.onload=b}function z(){for(var a=k.length,b=0;b<a;b++){var c=k[b].id;if(t.pv[0]>0){var d=I(c);d&&(k[b].width=d.getAttribute("width")?d.getAttribute("width"):"0",k[b].height=d.getAttribute("height")?d.getAttribute("height"):"0",L(k[b].swfVersion)?(t.webkit&&t.webkit<312&&A(d),N(c,!0)):k[b].expressInstall&&!s&&L("6.0.65")&&(t.win||t.mac)?B(k[b]):C(d))}else N(c,!0)}}function A(a){var c=a.getElementsByTagName(b)[0];if(c){var d=J("embed"),e=c.attributes;if(e)for(var f=e.length,g=0;g<f;g++)"DATA"==e[g].nodeName?d.setAttribute("src",e[g].nodeValue):d.setAttribute(e[g].nodeName,e[g].nodeValue);var h=c.childNodes;if(h)for(var i=h.length,j=0;j<i;j++)1==h[j].nodeType&&"PARAM"==h[j].nodeName&&d.setAttribute(h[j].getAttribute("name"),h[j].getAttribute("value"));a.parentNode.replaceChild(d,a)}}function B(a){s=!0;var b=I(a.id);if(b){if(a.altContentId){var c=I(a.altContentId);c&&(p=c,q=a.altContentId)}else p=D(b);!/%$/.test(a.width)&&parseInt(a.width,10)<310&&(a.width="310"),!/%$/.test(a.height)&&parseInt(a.height,10)<137&&(a.height="137"),h.title=h.title.slice(0,47)+" - Flash Player Installation";var d=t.ie&&t.win?"ActiveX":"PlugIn",e=h.title,i="MMredirectURL="+g.location+"&MMplayerType="+d+"&MMdoctitle="+e,j=a.id;if(t.ie&&t.win&&4!=b.readyState){var k=J("div");j+="SWFObjectNew",k.setAttribute("id",j),b.parentNode.insertBefore(k,b),b.style.display="none";var l=function(){b.parentNode.removeChild(b)};K(g,"onload",l)}E({data:a.expressInstall,id:f,width:a.width,height:a.height},{flashvars:i},j)}}function C(a){if(t.ie&&t.win&&4!=a.readyState){var b=J("div");a.parentNode.insertBefore(b,a),b.parentNode.replaceChild(D(a),b),a.style.display="none";var c=function(){a.parentNode.removeChild(a)};K(g,"onload",c)}else a.parentNode.replaceChild(D(a),a)}function D(a){var c=J("div");if(t.win&&t.ie)c.innerHTML=a.innerHTML;else{var d=a.getElementsByTagName(b)[0];if(d){var e=d.childNodes;if(e)for(var f=e.length,g=0;g<f;g++)1==e[g].nodeType&&"PARAM"==e[g].nodeName||8==e[g].nodeType||c.appendChild(e[g].cloneNode(!0))}}return c}function E(c,d,f){var g,h=I(f);if(h)if(typeof c.id==a&&(c.id=f),t.ie&&t.win){var i="";for(var j in c)c[j]!=Object.prototype[j]&&("data"==j.toLowerCase()?d.movie=c[j]:"styleclass"==j.toLowerCase()?i+=' class="'+c[j]+'"':"classid"!=j.toLowerCase()&&(i+=" "+j+'="'+c[j]+'"'));var k="";for(var m in d)d[m]!=Object.prototype[m]&&(k+='<param name="'+m+'" value="'+d[m]+'" />');h.outerHTML='<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"'+i+">"+k+"</object>",l[l.length]=c.id,g=I(c.id)}else if(t.webkit&&t.webkit<312){var n=J("embed");n.setAttribute("type",e);for(var o in c)c[o]!=Object.prototype[o]&&("data"==o.toLowerCase()?n.setAttribute("src",c[o]):"styleclass"==o.toLowerCase()?n.setAttribute("class",c[o]):"classid"!=o.toLowerCase()&&n.setAttribute(o,c[o]));for(var p in d)d[p]!=Object.prototype[p]&&"movie"!=p.toLowerCase()&&n.setAttribute(p,d[p]);h.parentNode.replaceChild(n,h),g=n}else{var q=J(b);q.setAttribute("type",e);for(var r in c)c[r]!=Object.prototype[r]&&("styleclass"==r.toLowerCase()?q.setAttribute("class",c[r]):"classid"!=r.toLowerCase()&&q.setAttribute(r,c[r]));for(var s in d)d[s]!=Object.prototype[s]&&"movie"!=s.toLowerCase()&&F(q,s,d[s]);h.parentNode.replaceChild(q,h),g=q}return g}function F(a,b,c){var d=J("param");d.setAttribute("name",b),d.setAttribute("value",c),a.appendChild(d)}function G(a){var b=I(a);!b||"OBJECT"!=b.nodeName&&"EMBED"!=b.nodeName||(t.ie&&t.win?4==b.readyState?H(a):g.attachEvent("onload",function(){H(a)}):b.parentNode.removeChild(b))}function H(a){var b=I(a);if(b){for(var c in b)"function"==typeof b[c]&&(b[c]=null);b.parentNode.removeChild(b)}}function I(a){var b=null;try{b=h.getElementById(a)}catch(a){}return b}function J(a){return h.createElement(a)}function K(a,b,c){a.attachEvent(b,c),m[m.length]=[a,b,c]}function L(a){var b=t.pv,c=a.split(".");return c[0]=parseInt(c[0],10),c[1]=parseInt(c[1],10)||0,c[2]=parseInt(c[2],10)||0,b[0]>c[0]||b[0]==c[0]&&b[1]>c[1]||b[0]==c[0]&&b[1]==c[1]&&b[2]>=c[2]}function M(c,d){if(!t.ie||!t.mac){var e=h.getElementsByTagName("head")[0],f=J("style");if(f.setAttribute("type","text/css"),f.setAttribute("media","screen"),t.ie&&t.win||typeof h.createTextNode==a||f.appendChild(h.createTextNode(c+" {"+d+"}")),e.appendChild(f),t.ie&&t.win&&typeof h.styleSheets!=a&&h.styleSheets.length>0){var g=h.styleSheets[h.styleSheets.length-1];typeof g.addRule==b&&g.addRule(c,d)}}}function N(a,b){var c=b?"visible":"hidden";r&&I(a)?I(a).style.visibility=c:M("#"+a,"visibility:"+c)}function O(a){var b=/[\\\"<>\.;]/,c=null!=b.exec(a);return c?encodeURIComponent(a):a}var n,a="undefined",b="object",c="Shockwave Flash",d="ShockwaveFlash.ShockwaveFlash",e="application/x-shockwave-flash",f="SWFObjectExprInst",g=window,h=document,i=navigator,j=[],k=[],l=[],m=[],o=null,p=null,q=null,r=!1,s=!1,t=function(){var f=typeof h.getElementById!=a&&typeof h.getElementsByTagName!=a&&typeof h.createElement!=a,j=[0,0,0],k=null;if(typeof i.plugins!=a&&typeof i.plugins[c]==b)k=i.plugins[c].description,!k||typeof i.mimeTypes!=a&&i.mimeTypes[e]&&!i.mimeTypes[e].enabledPlugin||(k=k.replace(/^.*\s+(\S+\s+\S+$)/,"$1"),j[0]=parseInt(k.replace(/^(.*)\..*$/,"$1"),10),j[1]=parseInt(k.replace(/^.*\.(.*)\s.*$/,"$1"),10),j[2]=/r/.test(k)?parseInt(k.replace(/^.*r(.*)$/,"$1"),10):0);else if(typeof g.ActiveXObject!=a){var l=null,m=!1;try{l=new ActiveXObject(d+".7")}catch(a){try{l=new ActiveXObject(d+".6"),j=[6,0,21],l.AllowScriptAccess="always"}catch(a){6==j[0]&&(m=!0)}if(!m)try{l=new ActiveXObject(d)}catch(a){}}if(!m&&l)try{k=l.GetVariable("$version"),k&&(k=k.split(" ")[1].split(","),j=[parseInt(k[0],10),parseInt(k[1],10),parseInt(k[2],10)])}catch(a){}}var n=i.userAgent.toLowerCase(),o=i.platform.toLowerCase(),p=!!/webkit/.test(n)&&parseFloat(n.replace(/^.*webkit\/(\d+(\.\d+)?).*$/,"$1")),q=!1,r=o?/win/.test(o):/win/.test(n),s=o?/mac/.test(o):/mac/.test(n);return{w3cdom:f,pv:j,webkit:p,ie:q,win:r,mac:s}}();(function(){if(t.w3cdom){if(x(z),t.ie&&t.win)try{h.write("<script id=__ie_ondomload defer=true src=//:></script>"),n=I("__ie_ondomload"),n&&K(n,"onreadystatechange",v)}catch(a){}t.webkit&&typeof h.readyState!=a&&(o=setInterval(function(){/loaded|complete/.test(h.readyState)&&w()},10)),typeof h.addEventListener!=a&&h.addEventListener("DOMContentLoaded",w,null),y(w)}})(),function(){t.ie&&t.win&&window.attachEvent("onunload",function(){for(var a=m.length,b=0;b<a;b++)m[b][0].detachEvent(m[b][1],m[b][2]);for(var c=l.length,d=0;d<c;d++)G(l[d]);for(var e in t)t[e]=null;t=null;for(var f in swfobject)swfobject[f]=null;swfobject=null})}();return{registerObject:function(a,b,c){if(t.w3cdom&&a&&b){var d={};d.id=a,d.swfVersion=b,d.expressInstall=!!c&&c,k[k.length]=d,N(a,!1)}},getObjectById:function(c){var d=null;if(t.w3cdom){var e=I(c);if(e){var f=e.getElementsByTagName(b)[0];!f||f&&typeof e.SetVariable!=a?d=e:typeof f.SetVariable!=a&&(d=f)}}return d},embedSWF:function(c,d,e,f,g,h,i,j,k){if(t.w3cdom&&c&&d&&e&&f&&g)if(e+="",f+="",L(g)){N(d,!1);var l={};if(k&&typeof k===b)for(var m in k)k[m]!=Object.prototype[m]&&(l[m]=k[m]);l.data=c,l.width=e,l.height=f;var n={};if(j&&typeof j===b)for(var o in j)j[o]!=Object.prototype[o]&&(n[o]=j[o]);if(i&&typeof i===b)for(var p in i)i[p]!=Object.prototype[p]&&(typeof n.flashvars!=a?n.flashvars+="&"+p+"="+i[p]:n.flashvars=p+"="+i[p]);x(function(){E(l,n,d),l.id==d&&N(d,!0)})}else h&&!s&&L("6.0.65")&&(t.win||t.mac)&&(s=!0,N(d,!1),x(function(){var a={};a.id=a.altContentId=d,a.width=e,a.height=f,a.expressInstall=h,B(a)}))},getFlashPlayerVersion:function(){return{major:t.pv[0],minor:t.pv[1],release:t.pv[2]}},hasFlashPlayerVersion:L,createSWF:function(a,b,c){return t.w3cdom?E(a,b,c):void 0},removeSWF:function(a){t.w3cdom&&G(a)},createCSS:function(a,b){t.w3cdom&&M(a,b)},addDomLoadEvent:x,addLoadEvent:y,getQueryParamValue:function(a){var b=h.location.search||h.location.hash;if(null==a)return O(b);if(b)for(var c=b.substring(1).split("&"),d=0;d<c.length;d++)if(c[d].substring(0,c[d].indexOf("="))==a)return O(c[d].substring(c[d].indexOf("=")+1));return""},expressInstallCallback:function(){if(s&&p){var a=I(f);a&&(a.parentNode.replaceChild(p,a),q&&(N(q,!0),t.ie&&t.win&&(p.style.display="block")),p=null,q=null,s=!1)}}}}();

/*
 * Required for the practice challenge on cme articles
 * jQuery BBQ: Back Button & Query Library - v1.3pre - 8/26/2010
 */
(function($,r){var h,n=Array.prototype.slice,t=decodeURIComponent,a=$.param,j,c,m,y,b=$.bbq=$.bbq||{},s,x,k,e=$.event.special,d="hashchange",B="querystring",F="fragment",z="elemUrlAttr",l="href",w="src",p=/^.*\?|#.*$/g,u,H,g,i,C,E={};function G(I){return typeof I==="string"}function D(J){var I=n.call(arguments,1);return function(){return J.apply(this,I.concat(n.call(arguments)))}}function o(I){return I.replace(H,"$2")}function q(I){return I.replace(/(?:^[^?#]*\?([^#]*).*$)?.*/,"$1")}function f(K,P,I,L,J){var R,O,N,Q,M;if(L!==h){N=I.match(K?H:/^([^#?]*)\??([^#]*)(#?.*)/);M=N[3]||"";if(J===2&&G(L)){O=L.replace(K?u:p,"")}else{Q=m(N[2]);L=G(L)?m[K?F:B](L):L;O=J===2?L:J===1?$.extend({},L,Q):$.extend({},Q,L);O=j(O);if(K){O=O.replace(g,t)}}R=N[1]+(K?C:O||!N[1]?"?":"")+O+M}else{R=P(I!==h?I:location.href)}return R}a[B]=D(f,0,q);a[F]=c=D(f,1,o);a.sorted=j=function(J,K){var I=[],L={};$.each(a(J,K).split("&"),function(P,M){var O=M.replace(/(?:%5B|=).*$/,""),N=L[O];if(!N){N=L[O]=[];I.push(O)}N.push(M)});return $.map(I.sort(),function(M){return L[M]}).join("&")};c.noEscape=function(J){J=J||"";var I=$.map(J.split(""),encodeURIComponent);g=new RegExp(I.join("|"),"g")};c.noEscape(",/");c.ajaxCrawlable=function(I){if(I!==h){if(I){u=/^.*(?:#!|#)/;H=/^([^#]*)(?:#!|#)?(.*)$/;C="#!"}else{u=/^.*#/;H=/^([^#]*)#?(.*)$/;C="#"}i=!!I}return i};c.ajaxCrawlable(0);$.deparam=m=function(L,I){var K={},J={"true":!0,"false":!1,"null":null};$.each(L.replace(/\+/g," ").split("&"),function(O,T){var N=T.split("="),S=t(N[0]),M,R=K,P=0,U=S.split("]["),Q=U.length-1;if(/\[/.test(U[0])&&/\]$/.test(U[Q])){U[Q]=U[Q].replace(/\]$/,"");U=U.shift().split("[").concat(U);Q=U.length-1}else{Q=0}if(N.length===2){M=t(N[1]);if(I){M=M&&!isNaN(M)?+M:M==="undefined"?h:J[M]!==h?J[M]:M}if(Q){for(;P<=Q;P++){S=U[P]===""?R.length:U[P];R=R[S]=P<Q?R[S]||(U[P+1]&&isNaN(U[P+1])?{}:[]):M}}else{if($.isArray(K[S])){K[S].push(M)}else{if(K[S]!==h){K[S]=[K[S],M]}else{K[S]=M}}}}else{if(S){K[S]=I?h:""}}});return K};function A(K,I,J){if(I===h||typeof I==="boolean"){J=I;I=a[K?F:B]()}else{I=G(I)?I.replace(K?u:p,""):I}return m(I,J)}m[B]=D(A,0);m[F]=y=D(A,1);$[z]||($[z]=function(I){return $.extend(E,I)})({a:l,base:l,iframe:w,img:w,input:w,form:"action",link:l,script:w});k=$[z];function v(L,J,K,I){if(!G(K)&&typeof K!=="object"){I=K;K=J;J=h}return this.each(function(){var O=$(this),M=J||k()[(this.nodeName||"").toLowerCase()]||"",N=M&&O.attr(M)||"";O.attr(M,a[L](N,K,I))})}$.fn[B]=D(v,B);$.fn[F]=D(v,F);b.pushState=s=function(L,I){if(G(L)&&/^#/.test(L)&&I===h){I=2}var K=L!==h,J=c(location.href,K?L:{},K?I:2);location.href=J};b.getState=x=function(I,J){return I===h||typeof I==="boolean"?y(I):y(J)[I]};b.removeState=function(I){var J={};if(I!==h){J=x();$.each($.isArray(I)?I:arguments,function(L,K){delete J[K]})}s(J,2)};e[d]=$.extend(e[d],{add:function(I){var K;function J(M){var L=M[F]=c();M.getState=function(N,O){return N===h||typeof N==="boolean"?m(L,N):m(L,O)[N]};K.apply(this,arguments)}if($.isFunction(I)){K=I;return J}else{K=I.handler;I.handler=J}}})})(jQuery,this);



//Article like feature
function addLikeIcon() {
    0 != $(".cme-article-tools .article_tools").length && $(".article_tools").append('<li><div class="like-icon"><img src="https://img.medscapestatic.com/pi/global/icons/icon-likes-outline.svg" class="ar-like" alt="Like" /><span class="like-count"></span></div></li>');
    $(".ar-like").on("click", likeHandler);
    fetchLikes()
}

//Disclaimer update
function updateDisclaimer() {
	const disclText =
	  'Content is current as of the date this activity was released.';
	if ($('#legal_block:contains("' + disclText + '")').length === 0) {
	  let discl = $('#legal_block')
		.find('*')
		.filter(function () {
		  return $(this).text().trim() == 'Disclaimer';
		});
  
	  if (discl && discl.length > 0) {
		$(discl[0]).parent() && $(discl[0]).parent().prop('tagName') === 'P'
		  ? $(discl[0])
			  .parent()
			  .after('<p>' + disclText + '</p>')
		  : $(discl[0]).after('<p>' + disclText + '</p>');
	  } else {
		$('#legal_block').prepend('<p>' + disclText + '</p>');
	  }
	}
  }

$(document).ready(function(){
	addLikeIcon();
	updateDisclaimer();
	$("body").on("keydown", function(e) {
        $('.cme-question label input').attr("tabindex", -1);
        $('.cme-question label').attr("tabindex", 0);
		if(!$(e.target).is('body') && $(e.target).is('.cme-question label')) {
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
           $(e.target).find('input').trigger('click');
           $(e.target).find('input').focus();
        }
		}
    });
})
function fetchLikes() {
    var hostname = location.hostname;
    var contentUri = location.pathname.split('_')[0];

    $.ajax({
        url: '//www.' + getDomain() + 'medscape.org/api/v1/contentfeedback/article_like/get_like_data',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
            like_requests: [
                {
                    hostName: hostname,
                    contentUri: contentUri
                }
            ]
        }),
        type: 'POST',
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        success: function(data) {
            updateLikeCount(data[0]);
        }
    });
}

function updateLikeCount(data){
    var likeCount = data.likeCount ? data.likeCount : '';
	$('.like-count').each(function(i, h){
		h.innerHTML = likeCount;
	})
	$('.ar-like').each(function(e, v){
		if (data.interactionType) {
			$(v).addClass('liked');
			$(v).attr('src', 'https://img.'+ getDomain() +'medscapestatic.com/pi/global/icons/icon-likes-liked.svg')
		} else {
			if($(v).hasClass('liked')){
				$(v).removeClass('liked');
				$(v).attr('src', 'https://img.'+ getDomain() +'medscapestatic.com/pi/global/icons/icon-likes-outline.svg')
			}
		}
		if (qrllog !== 1 && likeCount > 0) {
			$(v).addClass('active');
		}
	})
}


function addLikeClassAndCount(data, likeCount) {
    $('.like-count').text(likeCount);
    if (data.interactionType) {
        $('.ar-like').addClass('liked');
    } else {
        $('.ar-like').removeClass('liked');
    }
}

function likeHandler(event) {
    var i = $(event.target);
    if (i.off("click"),
    "1" === qrllog) {
        var e = location.hostname
          , t = location.pathname.split("_")[0]
          , a = "//www." + getDomain() + "medscape.org/api/v1/contentfeedback/article_like/handle_on_like";
        $.ajax({
            type: "POST",
            dataType: "json",
            xhrFields: {
                withCredentials: !0
            },
            crossDomain: !0,
            contentType: "application/json",
            url: a,
            data: JSON.stringify({
                like_requests: {
                    hostName: e,
                    contentUri: t
                }
            }),
            success: function(data) {
                var trackingText = "ar-cont_like";
                0 === data.interactionType && (trackingText = "ar-cont_unlike"),
                wmdPageLink(trackingText),
                updateLikeCount(data),
                i.on("click", likeHandler)
            }
        })
    }
}

window.nextButtonWidget = {
	showNextButton: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav");
		if($nextnav.length > 0)
			$nextnav.show();
	},
	hideNextButton: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav");
		if($nextnav.length > 0)
			$nextnav.hide();
	},
	getHref: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav>a");
		if($nextnav.length > 0) {
			return $nextnav.get(0).href;
		}
		return '';
	},
	getClickTrack: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav>a");
		if($nextnav.length > 0) {
			return $nextnav.attr('onclick');
		}
		return '';
	}
}
function videoQnARedirect(){
	if($(".webcomp-player").length && Object.keys(window.storedConfigs).length) {
		var videoConfigId = Object.keys(window.storedConfigs)[0];
		var videoConfg = window.storedConfigs[videoConfigId];
		var qnFormIds = [];
		var result = {};
		var queryParams = '';
		var redirectUrl = 'noscan/vidqna';
		var qnaProgressInfo = undefined;
		if(videoConfg.slideInfo.length) {
			$.each(videoConfg.slideInfo, function(key, val)  {
				qnFormIds.push(val.qaidFormPage);
			});
		}
		 if(qnFormIds.length) {
			var array = qnFormIds.map(function(i){ return i.match(/\d+/g); });
			$.each(array, function(index, item) {
				var key = item[0];
				var value = item[1];
			    
				if (!result[key]) {
				    result[key] = [];
				}
			    
				result[key].push(value);
			    });
			$(".webcomp-player").after('<div class="cme_btn-wrapper"><button class="cme_btn cme_btn--next">Next</button></div>');
			if(window.nextButtonWidget && typeof window.nextButtonWidget.hideNextButton === "function") {
				window.nextButtonWidget.hideNextButton();
			}
		}

		$(document).on('click', '.cme_btn--next', function(e) {
			
			//  && !qnaProgressInfo
			if(Object.keys(result).length) {
				// function to get qna info on click
				var qnaApiUrl= qna.qnaserviceurl+'/questionnaire/'+Object.keys(result)[0]+'?aggregated=true&_='+Date.now();
				$.ajax({
					type: "GET",
					url: qnaApiUrl,
					success: function(response){
						qnaProgressInfo = response;
						var qnForms = Object.values(result)[0]
						var filterQnForms = qnaProgressInfo.questionForms.filter(function(frm) { qnForms.includes(''+frm.formId) });
						var checkAnswered = filterQnForms.map(function(fm){ return fm.questions.some(function(qn){ return qn.answered; })});
						var redirectUser = checkAnswered.some(function(qn){ return !qn });
						if(redirectUser) {
							var url = window.location.origin+'/'+redirectUrl+'?param1='+Object.keys(result)[0]+'&param2='+qnForms.join(',')+'&param3=';
							var dynamicFn= window.nextButtonWidget.getClickTrack();
							if(dynamicFn) {
								var fn = new Function("",dynamicFn);
								// making tracking call from original next button click
								fn();
							}
							var nextBtnUrl = window.nextButtonWidget.getHref();
							if(nextBtnUrl) {
								url += nextBtnUrl;
							}
							window.location.href = url;
						}
					}
				});
			}
		});
	}
}

window.nextButtonWidget = {
	showNextButton: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav");
		if($nextnav.length > 0)
			$nextnav.show();
	},
	hideNextButton: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav");
		if($nextnav.length > 0)
			$nextnav.hide();
	},
	getHref: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav>a");
		if($nextnav.length > 0) {
			return $nextnav.get(0).href;
		}
		return '';
	},
	getClickTrack: function() {
		var $nextnav = jQuery(".cme-bodyleft #page_nav #next_page_nav>a");
		if($nextnav.length > 0) {
			return $nextnav.attr('onclick');
		}
		return '';
	}
}

$(window).on('load', function(){
	//videoQnARedirect();
})
